(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  // Theme 202.0 (home report 78, before-after row 4): the source header = [hdt-reveal][timeline] with [can-reveal] eyebrow + heading
  // (review-202/entr/stagger-src.json); its libs.js: in view with margin '0px 0px -88px 0px' -> each rises 20px -> 0 and fades 0 -> 1,
  // .075 s apart, ease [0, 0, .3, 1], Motion's default .3 s. Reduced motion = nothing hidden, nothing moves (Elad 10.10 Q1 'ב');
  // hidden here, by the script, so a script that does not run leaves the heading visible (LEARNED תתקלב).
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
    document.querySelectorAll('.ba__head').forEach(function (head) {
      var items = Array.prototype.slice.call(head.querySelectorAll('.ba__eyebrow, .ba__heading'));
      if (!items.length) return;
      items.forEach(function (el) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
      });
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        items.forEach(function (el, i) {
          var a = el.animate(
            [{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 300, delay: i * 75, easing: 'cubic-bezier(0, 0, 0.3, 1)', fill: 'both' }
          );
          a.finished.then(function () {
            el.style.opacity = '';
            el.style.transform = '';
            a.cancel();
          });
        });
      }, { rootMargin: '0px 0px -88px 0px' });
      io.observe(head);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-inova-banner"] && !Shopify.designMode) return;
  try {
    
  // Theme 98.0, 25.9.2026 - the source's AnimateElement (fade-up-large) and MarqueeElement, from
  // review-stli-14.9/source-js/bytes-20.9/theme.js; measured in review-cib-98/ (banner-entry.txt, banner-src.txt).
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    var rtl = document.documentElement.getAttribute('dir') === 'rtl';

    function entrance(root) {
      if (reduce) {
        root.classList.remove('is-entering');
        return;
      }
      var title = root.querySelector('.cinob__title');
      var words = Array.prototype.slice.call(root.querySelectorAll('.cinob__word-in'));
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        words.forEach(function (w, i) {
          var a = w.animate(
            [{ transform: 'translateY(90%)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }],
            { duration: 1000, delay: 500 + i * 30, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'both' }
          );
          a.finished.then(function () {
            w.parentElement.classList.add('is-done');
            a.cancel();
          });
        });
        root.classList.remove('is-entering');
      });
      io.observe(title);
    }

    // MarqueeElement: clones ceil(parent / child) + 2, --duration (33 - speed) * min(2.5, ceil(child / parent)) s,
    // parallax translateX(60% -> 0) over ["start end", "end start"] unless touch (then paused out of view).
    // 176.0 (Head 80.0): the source's ControlButton - the `paused` attribute + the label swap; the marquee gets
    // `is-stopped` (separate from the touch observer's `is-paused`, so scrolling back into view cannot restart it).
    function control(root) {
      var btn = root.querySelector('.cinob__control');
      var mq = root.querySelector('[data-cinob-mq]');
      if (!btn || !mq) return;
      btn.addEventListener('click', function () {
        var paused = !btn.hasAttribute('paused');
        btn.toggleAttribute('paused', paused);
        btn.setAttribute('aria-label', paused ? btn.dataset.playLabel : btn.dataset.pauseLabel);
        mq.classList.toggle('is-stopped', paused);
      });
    }

    function marquee(root) {
      var mq = root.querySelector('[data-cinob-mq]');
      if (!mq || reduce) return;
      var started = false;
      function start() {
        if (started) return;
        started = true;
        var child = mq.firstElementChild;
        var pw = mq.getBoundingClientRect().width;
        var cw = child.getBoundingClientRect().width;
        var max = cw > 0 ? Math.ceil(pw / cw) + 2 : 0;
        // 253.0 candidate 12b (4.11.2026): ONE animated track, static clones inside (candidate 5's pattern, topbar-inova.js initMarquee).
        // The clone count, the duration and the direction are unchanged; the track moves one text width per --cib-duration (the CSS).
        var track = document.createElement('span');
        track.className = 'cinob__mq-track';
        track.appendChild(child);
        for (var k = 0; k < max; k++) {
          var c = child.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          track.appendChild(c);
        }
        track.style.setProperty('--cib-clones', String(max + 1));
        mq.appendChild(track);
        track.classList.add('is-animated');
        mq.style.setProperty('--cib-duration', (33 - 5) * Math.min(2.5, Math.ceil(cw / pw)) + 's');
        if (!touch) {
          var shift = (1.5 * 100) / (1 + 1.5);
          if (rtl) shift = -shift;
          var ticking = false;
          var draw = function () {
            ticking = false;
            var r = mq.getBoundingClientRect();
            var vh = window.innerHeight;
            var p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
            mq.style.transform = 'translateX(' + shift * (1 - p) + '%)';
          };
          var onScroll = function () {
            if (!ticking) {
              ticking = true;
              requestAnimationFrame(draw);
            }
          };
          document.addEventListener('scroll', onScroll, { capture: true, passive: true });
          window.addEventListener('resize', onScroll);
          draw();
        }
        // 252.0 candidate 12 (3.11.2026): the is-paused observer ran only on touch; on desktop the 4 clones animated all the way down the
        // page (251 Report 5: 480 Animation restyles/s at every stop below the banner). Now on both: the root is the page's own scroll
        // container (div.page-wrapper on desktop - a margin on the implicit root is clipped at the scroller's edge, theme/LEARNED.md 3.11
        // 252.0; the document on touch, as before). The look: the belt moves whenever it is on screen, exactly as today.
        if ('IntersectionObserver' in window) {
          var root = mq.parentElement;
          while (root && root !== document.body && !(/(auto|scroll)/.test(getComputedStyle(root).overflowY) && root.scrollHeight > root.clientHeight)) root = root.parentElement;
          if (root === document.body) root = null;
          new IntersectionObserver(
            function (entries) {
              entries.forEach(function (e) {
                mq.classList.toggle('is-paused', !e.isIntersecting);
              });
            },
            { root: root, rootMargin: '0px 0px 50px 0px' }
          ).observe(mq);
        }
      }
      var io = new IntersectionObserver(
        function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          io.disconnect();
          start();
        },
        { rootMargin: '200px 0px 200px 0px' }
      );
      io.observe(mq);
    }

    function init(scope) {
      (scope || document).querySelectorAll('.cinob').forEach(function (root) {
        if (root.cinobReady) return;
        root.cinobReady = true;
        entrance(root);
        marquee(root);
        control(root);
      });
    }

    init();
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  // Theme 201.0 (home report 74 row 3, head 92.0): the banner's home icon = the source's magnet-link (home mouse-src.json:
  // -3,-3 -> +4.23,+4.23 over 20 px). The block below = collection-inova.liquid's 163.0 OF magnet copied VERBATIM, re-pointed at
  // .cinob__crumb-home (strength 10, as the header icons). Its own comment follows.
  // 🔁 163.0 OF: the filter tiles are `magnet-element` in the source (strength 10, the whole tile + caption moves; review-163/i6/out/
  // move6-1440.json -2.86 px at ~390 ms). The spring = footer-inova.js magnet() (F1, 135.0) verbatim; bound on the first pointerover,
  // so tiles swapped in by a filter refresh bind again. any-hover only; not touch, not reduced motion (Elad Q1 "ב").
  (function () {
    var root = document.querySelector('.cinob');
    if (!root) return;
    const magnet = (el, mover, strength) => {
      if (!window.matchMedia('(any-hover: hover)').matches) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const spring = (from, to, v0) => {
        const o = v0 ? v0 / 1000 : 0; const l = to - from; const w = Math.sqrt(100) / 1000; const z = 10 / (2 * Math.sqrt(100));
        const wd = w * Math.sqrt(1 - z * z);
        const h = (s) => to - Math.exp(-z * w * s) * (((z * w * l - o) / wd) * Math.sin(wd * s) + l * Math.cos(wd * s));
        const vel = (s) => { const q = Math.max(s - 5, 0); return s - q ? (h(s) - h(q)) * (1000 / (s - q)) : 0; };
        const kf = [h(0)];
        let s = 10;
        let done = Math.abs(o) <= 2 && Math.abs(to - h(0)) <= 0.5;
        while (!done && s < 10000) {
          const cur = h(s);
          done = Math.abs(vel(s)) <= 2 && Math.abs(to - cur) <= 0.5;
          kf.push(done ? to : cur);
          s += 10;
        }
        if (kf.length === 1) kf.push(h(0));
        return { h, vel, kf, dur: (kf.length - 1) * 10 };
      };
      const at = (g, s) => {
        if (s >= g.dur) return g.kf[g.kf.length - 1];
        const i = Math.floor(s / 10); const f = (s - i * 10) / 10;
        return g.kf[i] + (g.kf[i + 1] - g.kf[i]) * f;
      };
      const ax = [{ g: null, start: 0, v: 0 }, { g: null, start: 0, v: 0 }];
      let raf = 0;
      const paint = (now) => {
        let running = false;
        for (const a of ax) {
          if (!a.g) continue;
          const s = Math.max(0, now - a.start);
          a.v = at(a.g, s);
          if (s < a.g.dur) running = true;
        }
        mover.style.transform = (ax[0].v || ax[1].v) ? `translate(${ax[0].v.toFixed(3)}px, ${ax[1].v.toFixed(3)}px)` : '';
        raf = running ? requestAnimationFrame(paint) : 0;
      };
      const aim = (tx, ty) => {
        const tl = document.timeline.currentTime;
        [tx, ty].forEach((to, i) => {
          const a = ax[i];
          let from = 0;
          let v0 = 0;
          if (a.g) {
            const e = Math.max(0, tl - a.start);
            if (e >= a.g.dur) from = a.g.kf[a.g.kf.length - 1];
            else { from = a.g.h(e); v0 = a.g.vel(e); }
          }
          a.g = spring(from, to, v0);
          a.start = tl;
        });
        if (!raf) raf = requestAnimationFrame(paint);
      };
      el.addEventListener('pointermove', (e) => {
        if (e.pointerType === 'touch' || reduced.matches) return;
        const r = el.getBoundingClientRect();
        aim(((e.clientX - r.left) / el.offsetWidth - 0.5) * strength, ((e.clientY - r.top) / el.offsetHeight - 0.5) * strength);
      });
      el.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'touch' || reduced.matches) return;
        aim(0, 0);
      });
    };
    root.addEventListener('pointerover', function (e) {
      var el = e.target instanceof Element ? e.target.closest('.cinob__crumb-home') : null;
      if (!el || !root.contains(el) || el.cinobMagnet) return;
      el.cinobMagnet = true;
      magnet(el, el, 10);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-inova"] && !Shopify.designMode) return;
  try {
    
  // המתג Show on model, והסתרת עמודת המסננים.
  (function () {
    var root = document.querySelector('.cino');
    if (!root) return;

    var model = root.querySelector('[data-cino-model]');
    if (model) {
      model.addEventListener('click', function () {
        var on = root.classList.toggle('is-model');
        model.setAttribute('aria-pressed', on ? 'true' : 'false');
        var a = model.querySelector('[data-cino-model-on]');
        var b = model.querySelector('[data-cino-model-off]');
        if (a && b) { a.hidden = on; b.hidden = !on; }
      });
    }

    var toggle = root.querySelector('[data-cino-filters]');
    var side = root.querySelector('[data-cino-side]');
    if (toggle && side) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'false';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        // 143.0 B7: the label swaps like the source's (Hide filters / Show filters)
        var lab = toggle.querySelector('[data-cino-filters-label]');
        if (lab) lab.textContent = open ? toggle.getAttribute('data-show') : toggle.getAttribute('data-hide');
        // ⚠️ **הסתרה מזיזה את הרשת ומשנה כל מידה בה.** לכן העמודה
        // מקבלת רוחב 0 ולא `display: none` — הרשת גדלה, ושאר
        // המספרים נשארים נמדדים. סעיף קב.
        // ⚠️ להחזיר לערך של ה-CSS ולא ל-300 — הרוחב נוזלי מ-4.9.2026.
        side.style.inlineSize = open ? '0px' : '';
        side.style.flexBasis = open ? '0px' : '';
        side.style.overflow = open ? 'hidden' : '';
      });
    }

    // 🔁 152.0 G23: מ-1280, הסרגל בראש המסך ← body.cino-topbar--active (כלל `facets-topbar` של המקור: top === 0).
    // הגלילה אצלנו בתוך div.page-wrapper ולא בחלון — לכן capture על document. גם בטעינה ובשינוי גודל.
    var topbar = root.querySelector('.cino__topbar');
    if (topbar) {
      var wide = window.matchMedia('(min-width: 1280px)');
      var tbTick = false;
      var tbSync = function () {
        tbTick = false;
        document.body.classList.toggle('cino-topbar--active', wide.matches && topbar.getBoundingClientRect().top <= 0.5);
      };
      var tbLater = function () { if (!tbTick) { tbTick = true; requestAnimationFrame(tbSync); } };
      document.addEventListener('scroll', tbLater, { capture: true, passive: true });
      window.addEventListener('resize', tbLater);
      tbSync();
    }

    // 🔁 153.0 G1: התמונה המרחפת עוקבת אחרי העכבר (RevealButton של המקור, data-magnet 80) — רק בעכבר, לא במגע. הקישור עצמו לא זז.
    if (window.matchMedia('(any-hover: hover)').matches) {
      root.querySelectorAll('[data-cino-reveal-link]').forEach(function (link) {
        var img = link.querySelector('[data-cino-reveal]');
        if (!img || !img.animate) return;
        link.addEventListener('pointermove', function (e) {
          if (e.pointerType === 'touch') return;
          var r = link.getBoundingClientRect();
          var x = ((e.clientX - r.left) / link.offsetWidth - 0.5) * 80;
          var y = ((e.clientY - r.top) / link.offsetHeight - 0.5) * 80;
          img.animate({ opacity: 1, transform: 'translate(' + x + 'px, ' + y + 'px)' }, { duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200, easing: 'steps(2, start)', fill: 'forwards' });
        });
        link.addEventListener('pointerleave', function (e) {
          if (e.pointerType === 'touch') return;
          img.animate({ opacity: 0, transform: 'translate(0px, 0px)' }, { duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200, easing: 'cubic-bezier(0.61, 1, 0.88, 1)', fill: 'forwards' });
        });
      });
    }

    // תפריט המיון — נפתח כמו במקור, נסגר בלחיצה בחוץ וב-Escape.
    var sort = root.querySelector('[data-cino-sort]');
    var sortBtn = root.querySelector('[data-cino-sort-btn]');
    if (sort && sortBtn) {
      // 🔁 156.0 #32: the button grows from its rest box to the open box and back (the source's width / height transition). auto <-> px
      // cannot transition, so the rest box is written as inline px for one reflow; every inline value is cleared on transitionend,
      // a 650 ms fallback, or a window resize - nothing is left stuck. Fine pointer only (the source: no size transition on touch).
      var sortSized = function () { return window.matchMedia('(pointer: fine)').matches; };
      var sortEndTimer = null, sortCloseTimer = null;
      // 🔁 158.0 (step 2 S): the rest box is REMEMBERED - the copy in sortRest() is an insert, and on our page every insert restyles
      // all of it (review-158/c2: 23-29 ms inside the close click). Dropped -> the copy, once: any change inside the button (the sort choice
      // writes the label in the same task as setOpen(false) - read with takeRecords(), the callback would come too late), a resize, a web font.
      // 218.0: every sort box below is written back as a LAYOUT length (inline-size, --cino-sort-rw / rh, min-inline-size) - the rect is
      // DRAWN px under the site zoom: / the element's zoom (MDN Element.currentCSSZoom; 1 below 1280) - the hotspot-linea 4ad56cd0
      // helper. Measured (Home 24 TABLE24 #11): at 1518 the closing button shrank to ~.65 x .71, then jumped back at ~900 ms.
      var lbox = function (el) { var r = el.getBoundingClientRect(), z = el.currentCSSZoom || 1; return { width: r.width / z, height: r.height / z }; };
      var sortRestBox = null;
      var sortRestObs = new MutationObserver(function () { sortRestBox = null; });
      sortRestObs.observe(sortBtn, { childList: true, characterData: true, subtree: true });
      // 🔁 158.0 S2: a font that finishes while the sort is at rest re-reads the live box (== the copy at rest, rest_158) - the fonts land
      // after this script, and dropping alone made every first close measure the copy
      if (document.fonts) document.fonts.addEventListener('loadingdone', function () {
        if (!sort.classList.contains('is-open') && !sortEndTimer) { var fb = lbox(sortBtn); sortRestBox = { width: fb.width, height: fb.height }; } else sortRestBox = null;
      });
      var sortSettle = function () {
        clearTimeout(sortEndTimer); sortEndTimer = null;
        ['position', 'inset-block-start', 'inset-inline-end', 'inline-size', 'block-size'].forEach(function (p) { sortBtn.style.removeProperty(p); });
        if (!sort.classList.contains('is-open')) sort.style.minInlineSize = '';
      };
      sortBtn.addEventListener('transitionend', function (e) { if (e.target === sortBtn && e.propertyName === 'inline-size' && sortEndTimer) sortSettle(); });
      // 🔁 156.0 #32b/#32c: the rest box read off a fresh hidden copy (the live button's inner parts may be mid-transition - it read 181x56,
      // not 167x51), placed in the wrapper's parent so it takes the rest styles even while the wrapper is still open
      var sortRest = function () {
        if (sortRestObs.takeRecords().length) sortRestBox = null;
        if (sortRestBox) return sortRestBox;
        var copy = sortBtn.cloneNode(true), host = sort.parentElement;
        copy.removeAttribute('data-cino-sort-btn'); copy.setAttribute('aria-hidden', 'true'); copy.tabIndex = -1;
        copy.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;transition:none';
        host.appendChild(copy);
        var r = lbox(copy);
        host.removeChild(copy);
        return (sortRestBox = { width: r.width, height: r.height });
      };
      // hold the closing button at a box (absolute, inline-end fixed; the wrapper keeps the rest width) - the size transition runs only under (pointer: fine)
      // 🔁 156.0 #32e: the rest box for the list's clip (CSS: the clip = the button box)
      var sortClipTo = function (box) { sort.style.setProperty('--cino-sort-rw', box.width + 'px'); sort.style.setProperty('--cino-sort-rh', box.height + 'px'); };
      var sortHold = function (box, restW) {
        sort.style.minInlineSize = restW + 'px';
        sortClipTo(box);
        sortBtn.style.position = 'absolute'; sortBtn.style.insetBlockStart = '0'; sortBtn.style.insetInlineEnd = '0';
        sortBtn.style.inlineSize = box.width + 'px'; sortBtn.style.blockSize = box.height + 'px';
        clearTimeout(sortEndTimer); sortEndTimer = setTimeout(sortSettle, 650);
      };
      // 🔁 156.0 #32c: a resize during the shrink re-aims at the new rest (the source keeps shrinking to it), it does not snap
      // 🔁 156.0 #32f: and at rest the clip's rest box follows the resize - it must be in place BEFORE the class comes (a value written in
      // the same task as the class is not a transition start: clipbox_c32 read the clip at full width from the first frame)
      window.addEventListener('resize', function () {
        sortRestBox = null;
        if (sort.classList.contains('is-open')) return;
        if (sortEndTimer) { var r = sortRest(); sortHold(r, r.width); } else { var rb = lbox(sortBtn); sortClipTo(rb); sortRestBox = { width: rb.width, height: rb.height }; }
      });
      var rb0 = lbox(sortBtn); sortClipTo(rb0); sortRestBox = { width: rb0.width, height: rb0.height };
      var setOpen = function (on) {
        sortBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
        clearTimeout(sortCloseTimer); sortCloseTimer = null;
        if (on === sort.classList.contains('is-open')) return;
        if (sortEndTimer) sortSettle();
        // 🔁 140.0: המכל שומר את הרוחב שלו בפתיחה (במקור 200 גם פתוח); בלי זה הוא מתכווץ ל-0 והאפשרויות יוצאות מהמסך שמאלה
        if (on) sort.style.minInlineSize = lbox(sort).width + 'px';
        if (on) {
          if (!sortSized()) { sort.classList.add('is-open'); return; }
          var from = lbox(sortBtn);
          sortClipTo(from);
          sortBtn.style.inlineSize = from.width + 'px'; sortBtn.style.blockSize = from.height + 'px';
          sort.classList.add('is-open');
          void sortBtn.offsetWidth;
          sortBtn.style.removeProperty('inline-size'); sortBtn.style.removeProperty('block-size');
          return;
        }
        // the source's hide(): [open] leaves 100 ms after the close, on touch too (sortsize_c32 src: the box holds ~100 ms, then shrinks / jumps)
        // 🔁 156.0 #32d: the timer first, then the rest box read during the hold (a forced layout of this page is a 17-57 ms task -
        // busy_c32 / trace_c32 - and read before the timer it delayed the timer itself). At the close the class leaves and the rest size is
        // written in the same task: the CSS transition runs from the open size by itself - no read, no forced layout (the source ~3 ms).
        // Touch has no size transition, so the same write is a jump to the rest box, held while the inner parts finish (the source's box is fixed).
        var to = null;
        // 🔁 156.0 #32h-b: the fill on close = the source's hide() (fillclose_c32): the mouse still on the button (its own X) -> held full,
        // it leaves on the pointerleave; otherwise -> 0 -> -76 % over 600 ms after a 200 ms delay. Fine pointer only (the source skips it on touch).
        if (sortSized() && sortFill) {
          for (const a of sortFill.getAnimations()) a.cancel();
          var over = sortBtn.matches(':hover');
          var exit = sortFill.animate([{ transform: 'translate3d(0, 0, 0)' }, { transform: over ? 'translate3d(0, 0, 0)' : 'translate3d(0, -76%, 0)' }],
            { duration: over ? 1 : (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 600), delay: over || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200, easing: 'ease', fill: 'both' });
          // #32h-b2: timed from the click itself - the rest-box read below delays the next frame, where a start time is otherwise taken
          exit.startTime = document.timeline.currentTime;
        }
        sortCloseTimer = setTimeout(function () {
          sortCloseTimer = null;
          if (!to) to = sortRest();
          sort.classList.remove('is-open');
          sortHold(to, to.width);
        }, 100);
        to = sortRest();
      };
      sortBtn.addEventListener('click', function () {
        setOpen(!sort.classList.contains('is-open'));
      });
      document.addEventListener('click', function (e) {
        if (!sort.contains(e.target)) setOpen(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !sort.classList.contains('is-open')) return;
        var inside = sort.contains(document.activeElement);
        setOpen(false);
        if (inside) sortBtn.focus();
      });
      sort.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !sort.contains(e.relatedTarget)) setOpen(false);
      });
    }

    // 🔁 155.0 G5 (הראש 70.0): המילוי של כפתורי המקור (`.btn-fill`) — cinoFill הוא עותק של hoverFill ב-assets/stli-quick-view.js
    // (G4 מדד אותו שווה למקור פריים-פריים), עם הבדל מכוון אחד: 161.0: ובמצב "פחות תנועה" — בלי תנועה (אלעד Q1 "ב", סטייה מהמקור בשמו; המקור זז גם אז, fill_g5 REDUCE=1).
    // שני העותקים נבדקים זה מול זה: review-155/g5/fillcheck_g5_155.py.
    function cinoFill(btn) {
      const fill = btn.querySelector('[data-cino-fill]');
      if (!fill || !window.matchMedia('(any-hover: hover)').matches) return;
      const go = (from, to) => {
        const start = from || getComputedStyle(fill).transform;
        for (const a of fill.getAnimations()) a.cancel();
        fill.animate([{ transform: start }, { transform: to }],
          { duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 600, easing: 'ease', fill: 'forwards' });
      };
      btn.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'touch') go('translate3d(0, 76%, 0)', 'translate3d(0, 0, 0)');
      });
      btn.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'touch') go(null, 'translate3d(0, -76%, 0)');
      });
    }
    if (sort && sortBtn) {
      // המיון: שכבה אחת במקור (sortseq_g5) — בריחוף מכסה, בפתיחה גדלה ממנה, בסגירה מתכווצת ויוצאת למעלה. כשפתוח — המילוי לא זז
      // (נרשם לפני cinoFill ועוצר אותו), ובפתיחה השכבה עוברת מהאנימציה למצב הפתוח של ה-CSS בלי קפיצה.
      var sortFill = sortBtn.querySelector('[data-cino-fill]');
      var holdWhenOpen = function (e) { if (sort.classList.contains('is-open')) e.stopImmediatePropagation(); };
      sortBtn.addEventListener('pointerenter', holdWhenOpen);
      sortBtn.addEventListener('pointerleave', holdWhenOpen);
      sortBtn.addEventListener('click', function () {
        // 🔁 156.0 #32h-b2: the OPENING click only - aria-expanded flips at once, the class stays on through the 100 ms close hold
        if (!sortFill || sortBtn.getAttribute('aria-expanded') !== 'true') return;
        for (const a of sortFill.getAnimations()) { a.commitStyles(); a.cancel(); }
        requestAnimationFrame(function () { sortFill.style.transform = ''; });
      });
    }
    root.querySelectorAll('[data-cino-fill]').forEach(function (f) { cinoFill(f.parentElement); });

    // 186.0 btn-loader (Head 85.0 A; review-186/loader/PROPOSAL-loader.md): the one-variant add button shows the source's 3 dots while
    // ITS request runs. Start = Tinker's 'shopify:cart:lines-update' from our <product-form-component> (dispatched right before the
    // fetch), end = that event's own promise settling (success, 422 error, network failure) - never a timer. Delegated on the root:
    // a filter replaces the cards. Under reduced motion (Elad Q1 'ב') the swap jumps and the dots stay still - a named deviation.
    function cinoBusy(btn, on) {
      var loader = btn.querySelector('[data-cino-loader]');
      if (!loader) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var label = [].slice.call(btn.querySelectorAll('.cino__pill-icon, .cino__pill-text'));
      // busy fades hold their end (fill forwards); release fades CANCEL themselves when done, so the CSS owns opacity again
      // (Head 85.0: a finished forwards fade would pin the label / loader and override any later CSS - hover, reduce)
      var fade = function (els, to, delay, release) {
        els.forEach(function (el) {
          var from = getComputedStyle(el).opacity;
          if (el.__cinoFade) el.__cinoFade.cancel();
          var a = el.animate([{ opacity: from }, { opacity: to }], { duration: reduce ? 0 : 150, delay: reduce ? 0 : delay, easing: 'ease', fill: 'forwards' });
          el.__cinoFade = a;
          if (release) a.onfinish = function () { if (el.__cinoFade === a) { a.cancel(); el.__cinoFade = null; } };
        });
      };
      if (btn.__cinoDots) { btn.__cinoDots.forEach(function (a) { a.cancel(); }); btn.__cinoDots = null; }
      if (on) {
        btn.setAttribute('aria-busy', 'true');
        fade(label, 0, 0);
        fade([loader], 1, 150);
        if (!reduce) btn.__cinoDots = [].slice.call(loader.children).map(function (d, i) {
          return d.animate([{ transform: 'scale(1.6)' }, { transform: 'scale(0.6)' }], { duration: 350, delay: i * 175, direction: 'alternate', iterations: Infinity, easing: 'ease', fill: 'both' });
        });
      } else {
        btn.removeAttribute('aria-busy');
        fade([loader], 0, 0, true);
        fade(label, 1, 150, true);
      }
    }
    root.addEventListener('shopify:cart:lines-update', function (e) {
      var pf = e.target && e.target.closest ? e.target.closest('.cino__add-form') : null;
      var btn = pf && pf.querySelector('[data-cino-add]');
      if (!btn || !e.promise || typeof e.promise.then !== 'function') return;
      cinoBusy(btn, true);
      e.promise.then(function () {}, function () {}).then(function () { cinoBusy(btn, false); });
    });
    // a second click while busy: stopped before Tinker's on:submit sees it (component.js delegates on: events from document in the
    // capture phase, so this sits on window, capture - it runs first)
    if (!window.__cinoBusyGuard) {
      window.__cinoBusyGuard = true;
      window.addEventListener('submit', function (e) {
        var f = e.target;
        if (f && f.closest && f.closest('.cino__add-form') && f.querySelector('[data-cino-add][aria-busy="true"]')) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);
    }

    // ═══ 139.0 — C1 + C2 + C3, המנגנון של `facet-form` במקור (`review-139/ci/source-js/collection.js`) ═══
    // שינוי בטופס ← כתובת מ-FormData (מחיר ריק יורד) + `view` מהכתובת הנוכחית (הדרך של היום אל התבנית) ← `replaceState` ←
    // בקשת הסקשן (`section_id`), מבטלת את הקודמת, זיכרון של 50 ← החלפה של התוצאות, של כל קבוצת מסנן **חוץ מזו שנגעו בה**
    // (הפוקוס והקופסה נשארים), ושל המיון. העמודה עצמה לא מוחלפת (רוחב ההסתרה יושב עליה), וגם `is-model` נשאר על השורש.
    // 🔁 140.0 (C4): שני טפסים — העמודה והמגירה — כמו שני ה-`facet-form` של המקור; כל שינוי בונה כתובת מהטופס שבו קרה.
    // 🔁 160.0 item 11: the source's LazyImage (vendor.js) - a card image that is not complete gets its frame `is-loading` (CSS: opacity 0);
    // on load: requestIdleCallback(timeout 150) -> the frame loses it and the image fades in (CSS, mouse only). Race-safe: the listener first,
    // then the class, then complete is tested again. On error the source leaves it hidden (`.loading` stays) - so does this.
    var lazyFade = function (scope) {
      // 252.0 candidate 11b: cards out of view carry is-offscreen (their loading marks pause - the CSS above); root = the page's scroll
      // container (div.page-wrapper on desktop - a margin on the implicit root is clipped at the scroller's edge; the document on the phone)
      if ('IntersectionObserver' in window) {
        if (!root._cinoOffIO) {
          var sc = root.parentElement;
          while (sc && sc !== document.body && !(/(auto|scroll)/.test(getComputedStyle(sc).overflowY) && sc.scrollHeight > sc.clientHeight)) sc = sc.parentElement;
          if (sc === document.body) sc = null;
          root._cinoOffIO = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-offscreen', !e.isIntersecting); }); }, { root: sc, rootMargin: '0px' });
        }
        Array.prototype.forEach.call(scope.querySelectorAll('.cino__media'), function (m) { root._cinoOffIO.observe(m); });
      }
      Array.prototype.forEach.call(scope.querySelectorAll('.cino__media > .cino__img--main, .cino__slide > .cino__img'), function (img) {
        if (img.complete || img.classList.contains('is-loaded')) return;
        var media = img.parentElement;
        var shown = function () { img.classList.add('is-loaded'); media.classList.remove('is-loading'); };
        var done = function () { if (window.requestIdleCallback) window.requestIdleCallback(shown, { timeout: 150 }); else setTimeout(shown); };
        img.addEventListener('load', done, { once: true });
        media.classList.add('is-loading');
        if (img.complete && img.naturalWidth > 0) done();
      });
    };
    lazyFade(root);
    // 🔁 162.0 item 12: the loading mark stays still until the customer's first interaction - the source's body[data-page-rendering]
    // (theme.js: removed on the first click / mousemove / keydown / touchstart / touchmove / wheel, via requestIdleCallback)
    (function () {
      var ev = ['click', 'mousemove', 'keydown', 'touchstart', 'touchmove', 'wheel'];
      var go = function () {
        ev.forEach(function (t) { window.removeEventListener(t, go); });
        var run = function () { root.removeAttribute('data-cino-rendering'); };
        if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 1000 }); else setTimeout(run, 0);
      };
      ev.forEach(function (t) { window.addEventListener(t, go, { passive: true }); });
    })();

    var forms = Array.prototype.slice.call(root.querySelectorAll('[data-cino-form]'));
    var form = forms[0];
    var results = root.querySelector('[data-cino-results]');

    // 🔁 162.0 item 7a (Head 72.0 GO): the source's card motion - `motion-list` (theme.js) on load, `facet-form` before / after a filter
    // or sort render (collection.js); read in its own code + measured (review-162/i7/PROPOSAL-7.md). Desktop 50 px / .5 s / stagger .1;
    // small (max-width 767) or a touch device 30 / .3 / .05; easing ease. Reduced motion: none (Elad Q1 "ב" = the source's motionReduced).
    // "Visible" = the source's own test, as written there: rect.top < innerHeight + scrollY && rect.bottom > 0. The cards are hidden when
    // this script runs (= the source's unload() in its constructor) - no CSS pre-hide: a script error must not leave the grid hidden.
    var rm7 = window.matchMedia('(prefers-reduced-motion: reduce)');
    var p7 = function () {
      var small = window.matchMedia('(max-width: 767px)').matches || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      return small ? { d: 30, t: 300, s: 50 } : { d: 50, t: 500, s: 100 };
    };
    var cards7 = function () { return Array.prototype.slice.call(root.querySelectorAll('.cino__card')); };
    var split7 = function (list) {
      var vh = window.innerHeight + window.scrollY; var v = []; var o = [];
      list.forEach(function (c) { var r = c.getBoundingClientRect(); (r.top < vh && r.bottom > 0 ? v : o).push(c); });
      return [v, o];
    };
    var show7 = function (c) { c.style.removeProperty('transform'); c.style.removeProperty('opacity'); c.style.removeProperty('visibility'); };
    // d = null: fade only - the source's filter / sort path removes the card transform in the same task it starts the move (7a2,
    // box_rt_7: transform 'none' all through), so there its cards only fade; on load they rise
    var kf7 = function (d, inward) {
      var off = { opacity: 0, visibility: 'hidden' }; var on = { opacity: 1, visibility: 'visible' };
      if (d !== null) { off.transform = 'translateY(' + d + 'px)'; on.transform = 'translateY(0px)'; }
      return inward ? [off, on] : [on, off];
    };
    // in: the visible cards rise staggered from `at`; when they end, the rest rise together
    var in7 = function (list, at, p, fadeOnly) {
      var vo = split7(list); var d = fadeOnly ? null : p.d;
      vo[0].forEach(function (c, i) { show7(c); c.animate(kf7(d, true), { duration: p.t, delay: at + i * p.s, easing: 'ease', fill: 'backwards' }); });
      var rest = at + (vo[0].length ? p.t + (vo[0].length - 1) * p.s : 0);
      vo[1].forEach(function (c) { show7(c); c.animate(kf7(d, true), { duration: p.t, delay: rest, easing: 'ease', fill: 'backwards' }); });
    };
    var io7 = null;
    if (!rm7.matches && results && 'IntersectionObserver' in window && cards7().length) {
      var p0 = p7();
      cards7().forEach(function (c) { c.style.transform = 'translateY(' + p0.d + 'px)'; c.style.opacity = '0'; c.style.visibility = 'hidden'; });
      io7 = new IntersectionObserver(function (es) {
        if (!es.some(function (e) { return e.isIntersecting; })) return;
        io7.disconnect(); io7 = null; in7(cards7(), 0, p7());
      });
      io7.observe(results.querySelector('.cino__grid') || results);
    }
    // exit, before the fetch: ONE sequence like Motion.timeline - visible cards staggered, then the rest together, then the box (linear)
    var exit7 = function () {
      if (rm7.matches || !results) return null;
      var p = p7(); var vo = split7(cards7()); var a = [];
      vo[0].forEach(function (c, i) { a.push(c.animate(kf7(null, false), { duration: p.t, delay: i * p.s, easing: 'ease', fill: 'forwards' })); });
      var rest = vo[0].length ? p.t + (vo[0].length - 1) * p.s : 0;
      vo[1].forEach(function (c) { a.push(c.animate(kf7(null, false), { duration: p.t, delay: rest, easing: 'ease', fill: 'forwards' })); });
      a.push(results.animate([{ transform: 'translateY(0px)', opacity: 1 }, { transform: 'translateY(' + p.d + 'px)', opacity: 0 }],
        { duration: p.t, delay: rest + (vo[1].length ? p.t : 0), easing: 'linear', fill: 'forwards' }));
      return a;
    };
    // entry, after the swap: the box (linear), then the new cards as on load
    var enter7 = function (leaving) {
      if (leaving) leaving.forEach(function (x) { x.cancel(); });
      if (io7) { io7.disconnect(); io7 = null; }
      if (rm7.matches || !results) { cards7().forEach(show7); return; }
      var p = p7();
      results.animate([{ transform: 'translateY(' + p.d + 'px)', opacity: 0 }, { transform: 'translateY(0px)', opacity: 1 }], { duration: p.t, easing: 'linear', fill: 'backwards' });
      in7(cards7(), p.t, p, true);
    };
    var leaving7 = null;
    // 🔁 162.0 item 7b (Head 72.0 GO): the source's scroll to the collection top, 100 ms after a filter / sort click (collection.js
    // beforeRenderSection): the toolbar row (= its .collection) lands (touch || small ? 95 : 20) + header height [not small] below the top;
    // smooth, a jump under reduced motion; always - also when it is already in view, and behind the open phone drawer. It scrolls the page's
    // own scroller: div.page-wrapper on desktop (window.scrollY stays 0 there), else the document. Focus is NOT moved (deviation, Head 72.0:
    // the source loses it to body as a side effect of replacing its filter box).
    var scroller7 = function () {
      var pw = document.querySelector('.page-wrapper');
      return pw && pw.scrollHeight > pw.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) ? pw : null;
    };
    var scroll7 = function () {
      // the toolbar's NON-sticky parent (the toolbar sticks from 1280 - scrolled down its own rect is the stuck one); = the source's .collection
      var bar = root.querySelector('.cino__inner') || root.querySelector('.cino__grid'); if (!bar) return;
      var small = window.matchMedia('(max-width: 767px)').matches; var touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      var hd = document.querySelector('#header-component'); var hh = !small && hd ? hd.clientHeight : 0;
      var sc = scroller7(); var cur = sc ? sc.scrollTop : window.scrollY; var base = sc ? sc.getBoundingClientRect().top : 0;
      // 218.0: the two rects are DRAWN px under the site zoom, scrollTop / scrollTo LAYOUT px - their difference / the bar's zoom
      // (MDN Element.currentCSSZoom; 1 below 1280) - the hotspot-linea 4ad56cd0 helper; hh = clientHeight is layout already.
      var zf7 = bar.currentCSSZoom || 1;
      var top = Math.round((bar.getBoundingClientRect().top - base) / zf7 + cur - (touch || small ? 95 : (root.classList.contains('cino--row') ? 0 : 20)) - hh);
      // 'instant', not 'auto': base.css sets scroll-behavior: smooth on html and .page-wrapper, and 'auto' follows it (7b3)
      var how = { top: top, behavior: rm7.matches ? 'instant' : 'smooth' };
      if (sc) sc.scrollTo(how); else window.scrollTo(how);
    };
    // 256.0, Elad 4.11: "כל המזוזות" = the page's default choice; a chosen filter ends it (the address says so, also a filter hidden in the row), a press clears every filter and keeps the sort
    var allState = function () {
      var filtered = false; new URLSearchParams(location.search).forEach(function (v, k) { if (k.indexOf('filter.') === 0) filtered = true; });
      root.querySelectorAll('[data-cino-all]').forEach(function (a) { a.classList.toggle('is-default', !filtered); });
      return filtered;
    };
    if (form && results) {
      var sid = root.getAttribute('data-section-id');
      var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
      var cache = new Map();
      var ctrl = null;
      var buildUrl = function (base, f) {
        f = f || form;
        var u = new URL(base || f.action, location.href);
        if (!base) {
          u.search = '';
          new URLSearchParams(new FormData(f)).forEach(function (v, k) {
            if (v === '' && (k === 'sort_by' || k === 'page' || k.indexOf('filter.v.price.') === 0)) return;
            u.searchParams.append(k, v);
          });
        }
        var view = new URLSearchParams(location.search).get('view');
        if (view) u.searchParams.set('view', view);
        return u;
      };
      var apply = function (html, touched) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nr = doc.querySelector('[data-cino-results]');
        if (nr) { results.innerHTML = nr.innerHTML; lazyFade(results); }
        var nf = doc.querySelector('[data-cino-form]');
        if (nf) nf.querySelectorAll('[data-filter]').forEach(function (g) {
          var idx = g.getAttribute('data-index');
          var nb = g.querySelector('[data-filter-body]');
          forms.forEach(function (f) {
            var grp = f.querySelector('[data-filter][data-index="' + CSS.escape(idx) + '"]');
            if (!grp || grp === touched) return;
            var cur = grp.querySelector('[data-filter-body]');
            if (cur && nb) cur.innerHTML = nb.innerHTML;
          });
        });
        var ncount = doc.querySelector('[data-cino-results]');
        var cnt = root.querySelector('[data-cino-count]');
        if (ncount && cnt) cnt.textContent = ncount.getAttribute('data-count');
        var na = doc.querySelector('[data-cino-active-count]');
        // 163.0 item 15: two badges now (the toggle + the sticky button) - both take the new count
        if (na) root.querySelectorAll('[data-cino-active-count]').forEach(function (ca) { ca.textContent = na.textContent; ca.hidden = na.hasAttribute('hidden'); });
        var pairs = [['[data-cino-sort-list]', 'innerHTML'], ['[data-cino-sort-selection]', 'textContent']];
        pairs.forEach(function (q) { var a = doc.querySelector(q[0]); var b = root.querySelector(q[0]); if (a && b) b[q[1]] = a[q[1]]; });
        forms.forEach(function (f) {
          var ci = f.querySelector('[data-cino-sort-input]'); if (!ci) return;
          var ni = doc.querySelector(ci.tagName.toLowerCase() + '[data-cino-sort-input]');
          if (ni) ci.value = ni.value;
        });
      };
      var render = function (u, touched) {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        var signal = ctrl.signal;
        history.replaceState(history.state, '', u.toString());
        allState();
        u.searchParams.set('section_id', sid);
        var key = u.toString();
        var delay = rm.matches ? 0 : 500;
        var start = performance.now();
        results.classList.add('is-loading');
        if (leaving7) leaving7.forEach(function (x) { x.cancel(); });
        leaving7 = exit7(); // 162.0 item 7a
        setTimeout(scroll7, 100); // 162.0 item 7b
        var done = function (html) {
          setTimeout(function () {
            if (signal.aborted) return;
            apply(html, touched);
            enter7(leaving7); leaving7 = null; // 162.0 item 7a
            results.classList.remove('is-loading');
          }, Math.max(0, delay - (performance.now() - start)));
        };
        if (cache.has(key)) { done(cache.get(key)); return; }
        fetch(key, { signal: signal })
          .then(function (r) { return r.text(); })
          .then(function (html) { cache.set(key, html); if (cache.size > 50) cache.delete(cache.keys().next().value); done(html); })
          .catch(function (err) { if (err.name !== 'AbortError') { results.classList.remove('is-loading'); console.error(err); } });
      };
      // המחיר — כמו `price-range` של המקור: מספר שהשתנה נצמד (מינימום < מקסימום) ומזיז את המחוון; מחוון שזז כותב למספר
      var paint = function (box) {
        var max = parseInt(box.getAttribute('data-max'), 10) || 0; var wrap = box.querySelector('.cino__range-wrap'); if (!max || !wrap) return;
        wrap.style.setProperty('--range-min', (parseInt(box.querySelector('[data-range-min]').value, 10) || 0) / max * 100 + '%');
        wrap.style.setProperty('--range-max', (parseInt(box.querySelector('[data-range-max]').value, 10) || 0) / max * 100 + '%');
      };
      var clamp = function (t) {
        var box = t.closest('[data-price-range]'); if (!box) return;
        var max = parseInt(box.getAttribute('data-max'), 10) || 0;
        var lo = box.querySelector('[data-price-min]'); var hi = box.querySelector('[data-price-max]');
        if (t === lo && lo.value !== '') lo.value = Math.max(Math.min(parseInt(lo.value, 10) || 0, (parseInt(hi.value, 10) || max) - 1), 0);
        if (t === hi) hi.value = Math.min(Math.max(parseInt(hi.value || max, 10), (parseInt(lo.value, 10) || 0) + 1), max);
        box.querySelector('[data-range-min]').value = lo.value || 0;
        box.querySelector('[data-range-max]').value = hi.value || max;
        paint(box);
      };
      forms.forEach(function (form) {
      form.addEventListener('input', function (e) {
        var t = e.target; if (t.type !== 'range') return;
        var box = t.closest('[data-price-range]');
        var lo = box.querySelector('[data-range-min]'); var hi = box.querySelector('[data-range-max]');
        if (t === lo) { lo.value = Math.min(parseInt(lo.value, 10), parseInt(hi.value, 10) - 1); box.querySelector('[data-price-min]').value = lo.value; }
        else { hi.value = Math.max(parseInt(hi.value, 10), parseInt(lo.value, 10) + 1); box.querySelector('[data-price-max]').value = hi.value; }
        paint(box);
      });
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t.matches('[data-price-min], [data-price-max]')) clamp(t);
        render(buildUrl(null, form), t.closest('[data-filter]'));
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); render(buildUrl(null, form), null); });
      // 🔁 163.0 #38: the source's facet-sort onChange - the radio's value to the form's sort_by, the selection text = its label, close,
      // re-render. Arrows in the group move AND select (native radios) -> the same path, like the source. Focus back to our button.
      // 163.0 #38b: this block runs once per form (2) - one listener only
      if (!root.cinoSortChange) root.cinoSortChange = true, root.addEventListener('change', function (e) {
        var r = e.target.closest ? e.target.closest('.cino__sort-radio') : null;
        if (!r || !root.contains(r)) return;
        var lab = r.nextElementSibling;
        var ci = form.querySelector('[data-cino-sort-input]'); if (ci) ci.value = r.value;
        var sel = root.querySelector('[data-cino-sort-selection]'); if (sel && lab) sel.textContent = lab.textContent;
        var wasIn = document.activeElement === r;
        if (typeof setOpen === 'function') setOpen(false);
        var sb = root.querySelector('[data-cino-sort-btn]'); if (wasIn && sb) sb.focus();
        render(buildUrl(), null);
      });
      });
      root.addEventListener('click', function (e) {
        // 🔁 163.0 #38: the sort options are radios now - the one path is their `change` below (a label click checks the radio)
        var c = e.target.closest('[data-cino-clear]');
        if (c && root.contains(c)) { e.preventDefault(); render(buildUrl(c.href), null); }
        var all = e.target.closest('[data-cino-all]');
        if (all && root.contains(all)) {
          e.preventDefault(); if (!allState()) return;
          var au = new URL(all.href, location.href); var as = new URLSearchParams(location.search).get('sort_by'); if (as) au.searchParams.set('sort_by', as);
          render(buildUrl(au.toString()), null);
        }
      });
    }

    // ═══ 140.0 — C5a: ה-select של תת-הקולקציות מעביר לקולקציה, כמו `sub-collections` במקור ═══
    var sub = root.querySelector('[data-cino-subselect]');
    if (sub) sub.addEventListener('change', function () { if (sub.value) location.href = sub.value; });

    // ═══ 140.0 — C4: הכפתור הצף והמגירה (`facet-sticky` + `drawer-element` של המקור, `review-140/ci/source-js/theme.js`) ═══
    var float = root.querySelector('[data-cino-float]');
    var opener = root.querySelector('[data-cino-drawer-open]');
    var drawer = root.querySelector('[data-cino-drawer]');
    var end = root.querySelector('[data-cino-end]');
    if (float && 'IntersectionObserver' in window) {
      // 145.0: the source's rule 1:1 (facet-sticky, review-145/p3/facet-sticky-src.txt) - shown while the section's bottom is below
      // screen.availHeight - 200; the 140.0 rule (hidden once [data-cino-end] entered the window) hid it ~300 px early
      new IntersectionObserver(function (es) {
        float.classList.toggle('is-away', !es[0].isIntersecting);
      }, { rootMargin: '-' + (screen.availHeight - 200) + 'px 0px ' + screen.availHeight + 'px 0px' }).observe(root);
    }
    if (opener && drawer) {
      var panel = drawer.querySelector('[data-cino-drawer-panel]');
      var head = drawer.querySelector('[data-cino-drawer-head]');
      var overlay = drawer.querySelector('[data-cino-drawer-overlay]');
      var rmq = window.matchMedia('(prefers-reduced-motion: reduce)');
      var sheet = window.matchMedia('(max-width: 639px)');
      // ⚠️ הדף שלנו גולל ב-`.page-wrapper` ולא בחלון (LEARNED, 137.0) — הנעילה על שניהם, כמו `overflow: hidden` של המקור על body
      var lockEls = [document.body, document.querySelector('.page-wrapper')].filter(Boolean);
      var lock = function (on) {
        lockEls.forEach(function (el) {
          if (on) { el.setAttribute('data-cino-overflow', el.style.overflow); el.style.overflow = 'hidden'; }
          else if (el.hasAttribute('data-cino-overflow')) { el.style.overflow = el.getAttribute('data-cino-overflow'); el.removeAttribute('data-cino-overflow'); }
        });
      };
      var after = function (fn) {
        if (rmq.matches) { fn(); return; }
        var called = false;
        var once = function (e) { if (e && e.target !== panel) return; if (called) return; called = true; panel.removeEventListener('transitionend', once); fn(); };
        panel.addEventListener('transitionend', once);
        setTimeout(once, 700);
      };
      var focusables = function () {
        return Array.prototype.filter.call(panel.querySelectorAll('button, [href], input, select, textarea, summary, [tabindex]:not([tabindex="-1"])'), function (el) {
          return !el.disabled && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).opacity !== '0';
        });
      };
      var isOpen = function () { return drawer.classList.contains('is-open'); };
      var openDrawer = function () {
        if (isOpen()) return;
        drawer.hidden = false;
        void panel.offsetWidth;
        drawer.classList.add('is-open');
        // 🔁 159.0 #48 (Elad 8.10): the WhatsApp bubble hides while this drawer is open - an attribute on <html>, read by base.css
        document.documentElement.setAttribute('data-cino-drawer-shown', '');
        opener.setAttribute('aria-expanded', 'true');
        lock(true);
        after(function () { if (isOpen()) head.focus({ preventScroll: true }); });
      };
      var closeDrawer = function () {
        if (!isOpen()) return;
        drawer.classList.remove('is-open');
        document.documentElement.removeAttribute('data-cino-drawer-shown');
        opener.setAttribute('aria-expanded', 'false');
        lock(false);
        after(function () {
          if (isOpen()) return;
          drawer.hidden = true;
          panel.style.transform = ''; panel.style.transition = ''; overlay.style.opacity = ''; overlay.style.transition = '';
        });
        opener.focus({ preventScroll: true });
      };
      opener.addEventListener('click', openDrawer);
      drawer.addEventListener('click', function (e) { if (e.target.closest('[data-cino-drawer-close]')) closeDrawer(); });
      document.addEventListener('keydown', function (e) {
        if (!isOpen()) return;
        if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
        if (e.key !== 'Tab') return;
        var f = focusables(); if (!f.length) return;
        var first = f[0]; var last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === head)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      });
      // מתחת ל-640: גרירת הכותרת למטה — `onPanMove` / `onPanEnd` של המקור: עוקב עד גובה פחות 50, הרקע נחלש ביחס,
      // שחרור אחרי 30% מהגובה סוגר; פחות מזה חוזר.
      var startY = null; var h = 0; var moveY = 0; var frame = null;
      head.addEventListener('touchstart', function (e) {
        if (!sheet.matches || !isOpen()) return;
        startY = e.changedTouches[0].screenY; moveY = 0; h = panel.getBoundingClientRect().height;
      }, { passive: true });
      head.addEventListener('touchmove', function (e) {
        if (startY === null) return;
        moveY = e.changedTouches[0].screenY - startY;
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          panel.style.transition = 'transform .1s linear'; overlay.style.transition = 'opacity .1s linear';
          if (moveY >= 0) { panel.style.transform = 'translateY(' + Math.min(moveY, h - 50) + 'px)'; overlay.style.opacity = String(Math.min(1, Math.max(0, 1 - moveY / h))); }
          else { panel.style.transform = 'translateY(0)'; overlay.style.opacity = '1'; }
        });
      }, { passive: true });
      head.addEventListener('touchend', function () {
        if (startY === null) return;
        startY = null;
        if (frame) { cancelAnimationFrame(frame); frame = null; }
        var rmRel = window.matchMedia('(prefers-reduced-motion: reduce)').matches; // 161.0 Q1: reduced motion - the release jumps (no .1s), and closes without waiting for a transitionend
        panel.style.transition = rmRel ? 'none' : 'transform .1s linear';
        if (moveY < h * 0.3) { panel.style.transform = 'translateY(0)'; overlay.style.opacity = ''; return; }
        panel.style.transform = 'translateY(' + h + 'px)';
        if (rmRel) { closeDrawer(); return; }
        var gone = function () { panel.removeEventListener('transitionend', gone); closeDrawer(); };
        panel.addEventListener('transitionend', gone);
      }, { passive: true });
    }
  })();

  // 🔁 163.0 OF: the filter tiles are `magnet-element` in the source (strength 10, the whole tile + caption moves; review-163/i6/out/
  // move6-1440.json -2.86 px at ~390 ms). The spring = footer-inova.js magnet() (F1, 135.0) verbatim; bound on the first pointerover,
  // so tiles swapped in by a filter refresh bind again. any-hover only; not touch, not reduced motion (Elad Q1 "ב").
  (function () {
    var root = document.querySelector('.cino');
    if (!root) return;
    const magnet = (el, mover, strength) => {
      if (!window.matchMedia('(any-hover: hover)').matches) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const spring = (from, to, v0) => {
        const o = v0 ? v0 / 1000 : 0; const l = to - from; const w = Math.sqrt(100) / 1000; const z = 10 / (2 * Math.sqrt(100));
        const wd = w * Math.sqrt(1 - z * z);
        const h = (s) => to - Math.exp(-z * w * s) * (((z * w * l - o) / wd) * Math.sin(wd * s) + l * Math.cos(wd * s));
        const vel = (s) => { const q = Math.max(s - 5, 0); return s - q ? (h(s) - h(q)) * (1000 / (s - q)) : 0; };
        const kf = [h(0)];
        let s = 10;
        let done = Math.abs(o) <= 2 && Math.abs(to - h(0)) <= 0.5;
        while (!done && s < 10000) {
          const cur = h(s);
          done = Math.abs(vel(s)) <= 2 && Math.abs(to - cur) <= 0.5;
          kf.push(done ? to : cur);
          s += 10;
        }
        if (kf.length === 1) kf.push(h(0));
        return { h, vel, kf, dur: (kf.length - 1) * 10 };
      };
      const at = (g, s) => {
        if (s >= g.dur) return g.kf[g.kf.length - 1];
        const i = Math.floor(s / 10); const f = (s - i * 10) / 10;
        return g.kf[i] + (g.kf[i + 1] - g.kf[i]) * f;
      };
      const ax = [{ g: null, start: 0, v: 0 }, { g: null, start: 0, v: 0 }];
      let raf = 0;
      const paint = (now) => {
        let running = false;
        for (const a of ax) {
          if (!a.g) continue;
          const s = Math.max(0, now - a.start);
          a.v = at(a.g, s);
          if (s < a.g.dur) running = true;
        }
        mover.style.transform = (ax[0].v || ax[1].v) ? `translate(${ax[0].v.toFixed(3)}px, ${ax[1].v.toFixed(3)}px)` : '';
        raf = running ? requestAnimationFrame(paint) : 0;
      };
      const aim = (tx, ty) => {
        const tl = document.timeline.currentTime;
        [tx, ty].forEach((to, i) => {
          const a = ax[i];
          let from = 0;
          let v0 = 0;
          if (a.g) {
            const e = Math.max(0, tl - a.start);
            if (e >= a.g.dur) from = a.g.kf[a.g.kf.length - 1];
            else { from = a.g.h(e); v0 = a.g.vel(e); }
          }
          a.g = spring(from, to, v0);
          a.start = tl;
        });
        if (!raf) raf = requestAnimationFrame(paint);
      };
      el.addEventListener('pointermove', (e) => {
        if (e.pointerType === 'touch' || reduced.matches) return;
        const r = el.getBoundingClientRect();
        aim(((e.clientX - r.left) / el.offsetWidth - 0.5) * strength, ((e.clientY - r.top) / el.offsetHeight - 0.5) * strength);
      });
      el.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'touch' || reduced.matches) return;
        aim(0, 0);
      });
    };
    root.addEventListener('pointerover', function (e) {
      var el = e.target instanceof Element ? e.target.closest('[data-cino-magnet]') : null;
      if (!el || !root.contains(el) || el.cinoMagnet) return;
      el.cinoMagnet = true;
      magnet(el, el, 10);
    });
  })();

  // 🔁 154.0 G2 (הראש 70.0): ריחוף על תמונת כרטיס — `SecondaryMedia` של המקור (Flickity: wrapAround, rightToLeft לפי כיוון
  // העמוד, גרירה כבויה). 2 תמונות -> השנייה; 3 -> חצאים; 4 -> שלישים, לפי מרחק העכבר מהקצה השמאלי; יציאה -> הראשונה. התנועה —
  // הפיזיקה של Flickity פריים-פריים (משיכה .025, חיכוך .28), נמדד זהה במקור ל-0.01% (review-154/g2/out/curve-src-*.json).
  (function () {
    var root = document.querySelector('.cino');
    if (!root) return;
    var DIR = -1;
    var mod = function (n, m) { return ((n % m) + m) % m; };
    var state = function (el) {
      if (el.cinoS) return el.cinoS;
      var track = el.querySelector('[data-cino-track]');
      var cells = Array.prototype.slice.call(track.children);
      var box = el.closest('.cino__mediabox');
      var s = el.cinoS = { el: el, track: track, cells: cells, n: cells.length, x: 0, v: 0, idx: 0, sel: 0, rest: 0, raf: null,
        dots: box ? Array.prototype.slice.call(box.querySelectorAll('.cino__dot')) : [] };
      el.cinoGo = function (i, instant) { select(s, i); if (instant) { s.x = -s.idx * 100; s.v = 0; settle(s); } };
      return s;
    };
    var paint = function (s) {
      var n = s.n, x = s.x;
      s.track.style.transform = 'translateX(' + (DIR * x) + '%)';
      for (var i = 0; i < n; i++) {
        var rel = mod(i * 100 + x + 100, n * 100) - 100;
        s.cells[i].style.transform = 'translateX(' + (DIR * (rel - x)) + '%)';
      }
    };
    var settle = function (s) {
      s.idx = mod(s.idx, s.n); s.x = -s.idx * 100; s.v = 0; s.rest = 0;
      if (s.raf) { cancelAnimationFrame(s.raf); s.raf = null; }
      paint(s);
    };
    var tick = function (s) {
      var w = s.el.getBoundingClientRect().width || 1;
      var prev = s.x;
      s.v += (-s.idx * 100 - s.x) * 0.025;
      s.x += s.v;
      s.v *= 0.72;
      paint(s);
      if (Math.round(s.x * w) === Math.round(prev * w)) s.rest++; else s.rest = 0;
      if (s.rest > 2) { settle(s); return; }
      s.raf = requestAnimationFrame(function () { tick(s); });
    };
    var select = function (s, index) {
      var n = s.n, cur = mod(s.idx, n);
      if (s.idx !== cur) { s.x += (s.idx - cur) * 100; s.idx = cur; }
      var w = mod(index, n), d = Math.abs(w - cur), back = Math.abs(w + n - cur), fore = Math.abs(w - n - cur);
      var to = w;
      if (back < d) to = w + n; else if (fore < d) to = w - n;
      if (to === s.idx && s.sel === w) return;
      s.idx = to; s.sel = w;
      s.el.setAttribute('data-cino-slide', String(w));
      s.dots.forEach(function (dot, k) { dot.classList.toggle('is-selected', k === w); });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { settle(s); return; } // 161.0 Q1: reduced motion - the slide jumps, no spring
      if (!s.raf) s.raf = requestAnimationFrame(function () { tick(s); });
    };
    root.addEventListener('mousemove', function (e) {
      var el = e.target.closest && e.target.closest('[data-cino-slides]');
      if (!el || root.classList.contains('is-model') || el.offsetParent === null) return;
      var s = state(el);
      if (s.n < 2) return;
      if (s.n === 2) { select(s, 1); return; }
      var r = el.getBoundingClientRect(), mx = e.clientX - r.left;
      if (s.n === 3) { select(s, mx < r.width / 2 ? 1 : 2); return; }
      select(s, mx < r.width / 3 ? 1 : mx < 2 * r.width / 3 ? 2 : 3);
    });
    root.addEventListener('mouseout', function (e) {
      var el = e.target.closest && e.target.closest('[data-cino-slides]');
      if (!el || !el.cinoS) return;
      if (e.relatedTarget && el.contains(e.relatedTarget)) return;
      select(el.cinoS, 0);
    });
  })();
  // 🔁 182.0 #153: <cino-countdown> - the source CountdownTimer (refs/inova/footer/theme.js): starts in view (200 px margin), 1 s tick, compact
  // text, days left out at 0; past -> interval cleared + the timer hidden (the pill + icon stay, as the source). One interval per element:
  // a second start is ignored and disconnecting (the editor re-renders the section) clears it.
  (function () {
    if (!('customElements' in window) || customElements.get('cino-countdown')) return;
    class CinoCountdown extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) { this.start(); return; }
        this._io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { this._io.disconnect(); this._io = null; this.start(); } }, { rootMargin: '200px 0px 200px 0px' });
        this._io.observe(this);
      }
      disconnectedCallback() {
        if (this._io) { this._io.disconnect(); this._io = null; }
        if (this._t) { clearInterval(this._t); this._t = null; }
      }
      start() {
        if (this._t) return;
        this._end = new Date(this.getAttribute('data-expires'));
        this._u = (this.getAttribute('data-units') || 'd,h,m,s').split(',').map((s) => s.trim());
        if (isNaN(this._end)) { this.hidden = true; return; }
        if (this.tick()) this._t = setInterval(() => this.tick(), 1000);
      }
      tick() {
        const d = this._end - new Date();
        if (d < 0) { if (this._t) { clearInterval(this._t); this._t = null; } this.hidden = true; return false; }
        const day = 864e5, hr = 36e5;
        const v = [Math.floor(d / day), Math.floor((d % day) / hr), Math.floor((d % day % hr) / 6e4), Math.floor((d % day % hr % 6e4) / 1e3)];
        const items = v.map((n, i) => (i === 0 && n === 0 ? '' : '<span class="cino__countdown-item">' + n + (this._u[i] || '') + '</span>'));
        this.innerHTML = items.join('');
        return true;
      }
    }
    customElements.define('cino-countdown', CinoCountdown);
  })();
  // 🔁 184.0 G7: <cino-promo-video> - the source's DeferredMedia on the promo tile: muted / loop / inline, plays while in view, pauses out of
  // view. Under reduced motion it never starts and the poster stays (Elad Q1 'ב', START_HERE:792; the source keeps playing - a named deviation).
  // One element per tile; the filter re-render replaces it, and connectedCallback binds the new one.
  (function () {
    if (!('customElements' in window) || customElements.get('cino-promo-video')) return;
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
    // Head 84.0: MediaQueryList.addEventListener is missing on Safari < 14 (it would throw here) - the older addListener / removeListener
    var on = function (f) { if (rm.addEventListener) rm.addEventListener('change', f); else if (rm.addListener) rm.addListener(f); };
    var off = function (f) { if (rm.removeEventListener) rm.removeEventListener('change', f); else if (rm.removeListener) rm.removeListener(f); };
    class CinoPromoVideo extends HTMLElement {
      connectedCallback() {
        this._v = this.querySelector('video');
        if (!this._v) return;
        this._v.muted = true;
        this._rm = () => { if (rm.matches) this._v.pause(); else if (this._in) this.play(); };
        on(this._rm);
        if (!('IntersectionObserver' in window)) { this._in = true; this.play(); return; }
        this._io = new IntersectionObserver((es) => { this._in = es.some((e) => e.isIntersecting); if (this._in) this.play(); else this._v.pause(); });
        this._io.observe(this);
      }
      disconnectedCallback() {
        if (this._io) { this._io.disconnect(); this._io = null; }
        if (this._rm) { off(this._rm); this._rm = null; }
      }
      play() {
        if (rm.matches) return; // 184.0 G7: reduced motion - never starts (the KA plant removes this line and must go RED)
        var p = this._v.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
    customElements.define('cino-promo-video', CinoPromoVideo);
  })();

  // Theme 202.0 (home report 87 row 138): the filter groups animate open / closed like the source's AccordionDetails.transition
  // (height summary <-> full 250ms ease; the body fades in and rises 10px over 150ms from +150ms; closing = the body fades out
  // 150ms while the height returns, then `open` is removed). The code = assets/footer-inova.js's accordion (the same source
  // transition, measured equal there), copied; reduced motion = a jump (Elad 10.10 Q1 'ב'); a newer tap wins (head 60.0).
  // The source groups are independent (not in <accordions-details>) - nothing closes the others (review-202/acc/facet-src.json).
  (function () {
    var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var anims = new Map();   // details -> { want, list }
    var stop = function (d) {
      var run = anims.get(d);
      if (!run) return;
      anims.delete(d);
      run.list.forEach(function (a) { a.cancel(); });
      d.style.overflow = '';
      d.removeAttribute('data-cino-closing');
    };
    var animate = function (d, want) {
      var summary = d.querySelector('summary');
      var content = summary && summary.nextElementSibling;
      var from = d.getBoundingClientRect().height;   // read BEFORE cancelling: the height on screen right now
      var fade = content ? getComputedStyle(content).opacity : '1';
      stop(d);
      if (!summary || !content || typeof d.animate !== 'function' || mqReduce.matches) { d.open = want; return; }
      d.style.overflow = 'hidden';
      if (want) d.open = true;
      else d.setAttribute('data-cino-closing', '');   // Theme 203.0: the chevron turns at the tap, like the source
      var borders = d.offsetHeight - d.clientHeight;   // the animated height is a border box
      var to = (want ? d.scrollHeight : summary.offsetHeight) + borders;
      var list = want
        ? [
          d.animate({ height: [from + 'px', to + 'px'] }, { duration: 250, easing: 'ease' }),
          content.animate({ opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] }, { duration: 150, delay: 150, easing: 'ease', fill: 'backwards' })
        ]
        : [
          content.animate({ opacity: [fade, 0] }, { duration: 150, easing: 'ease', fill: 'forwards' }),
          d.animate({ height: [from + 'px', to + 'px'] }, { duration: 250, easing: 'ease' })
        ];
      var run = { want: want, list: list };
      anims.set(d, run);
      var height = want ? list[0] : list[1];         // the 250ms height animation ends the transition
      height.finished.then(function () {
        if (anims.get(d) !== run) return;              // cancelled by a newer tap
        if (!want) d.open = false;
        stop(d);                                        // also drops the content's fill
      }, function () {});
    };
    document.querySelectorAll('.cino').forEach(function (root) {
      root.addEventListener('click', function (e) {
        var summary = e.target instanceof Element ? e.target.closest('summary.cino__facet-summary') : null;
        var d = summary && summary.parentElement;
        if (!d || d.tagName !== 'DETAILS' || !root.contains(d)) return;
        e.preventDefault();
        var run = anims.get(d);
        animate(d, !(run ? run.want : d.open));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-linea-strip"] && !Shopify.designMode) return;
  try {
    
  // Theme 98.0, 25.9.2026 - splide's Drag (review-cls-98/source-js/vendor.js, `Drag:function`) on our strip at <= 640:
  // data-splide breakpoint 640 { drag: true, fixedWidth: 45%, perMove: 1, speed: 400, flickPower: 200 }, type slide,
  // trimSpace. pos is splide's translate (forward negative); the items share one transform, mirrored in RTL.
  (function () {
    var MQ = window.matchMedia('(max-width: 640px)');

    function Strip(track) {
      this.track = track;
      this.active = false;
      // 126.0 (G16a): splide's Drag mount() binds dragstart -> preventDefault on the track ALWAYS; `drag: false` above 640 only
      // disables the pointer drag. So the photo / name never ghost-drag, at any width (review-126/s16/). Until 126.0 this sat in activate().
      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
      this.onChange = this.update.bind(this);
      MQ.addEventListener('change', this.onChange);
      this.update();
    }

    Strip.prototype.update = function () {
      if (MQ.matches) this.activate();
      else this.deactivate();
    };

    Strip.prototype.activate = function () {
      if (this.active) return;
      this.active = true;
      var self = this;
      this.rtl = window.getComputedStyle(this.track).direction === 'rtl';
      this.track.classList.add('is-drag');
      this.pos = 0;
      this.index = 0;
      this.measure();
      this.mark();
      this.onDown = this.down.bind(this);
      this.onMove = this.move.bind(this);
      this.onUp = this.up.bind(this);
      this.onClick = function (e) {
        if (self.preventClick) {
          e.preventDefault();
          e.stopPropagation();
        }
      };
      this.onResize = function () {
        if (!self.active) return;
        self.measure();
        self.set(self.posOf(self.index), false);
      };
      this.onEnd = function (e) {
        if (e.target.parentNode === self.track) self.track.classList.remove('is-going');
      };
      this.track.addEventListener('pointerdown', this.onDown);
      this.track.addEventListener('click', this.onClick, true);
      this.track.addEventListener('transitionend', this.onEnd);
      window.addEventListener('resize', this.onResize);
    };

    Strip.prototype.deactivate = function () {
      if (!this.active) return;
      this.active = false;
      this.release();
      this.track.removeEventListener('pointerdown', this.onDown);
      this.track.removeEventListener('click', this.onClick, true);
      this.track.removeEventListener('transitionend', this.onEnd);
      window.removeEventListener('resize', this.onResize);
      this.track.classList.remove('is-drag', 'is-going');
      Array.prototype.forEach.call(this.track.children, function (li) {
        li.classList.remove('is-active');
      });
      this.track.style.removeProperty('--cls-x');
    };

    // Layout: each card's start from the track's start (at pos 0), the end limit (trimSpace), the list size (the view).
    Strip.prototype.measure = function () {
      var t = this.track;
      t.classList.remove('is-going');
      t.style.setProperty('--cls-x', '0px');
      var tb = t.getBoundingClientRect();
      var rtl = this.rtl;
      var end = 0;
      this.offsets = Array.prototype.map.call(t.children, function (li) {
        var b = li.getBoundingClientRect();
        var o = rtl ? tb.right - b.right : b.left - tb.left;
        end = Math.max(end, o + b.width);
        return o;
      });
      this.size = t.clientWidth;
      this.limit = Math.max(0, end - this.size);
      this.set(this.pos || 0, false);
    };

    Strip.prototype.posOf = function (k) {
      return Math.max(-this.offsets[k], -this.limit);
    };

    Strip.prototype.set = function (p, animate) {
      this.pos = p;
      this.track.classList.toggle('is-going', !!animate);
      this.track.style.setProperty('--cls-x', (this.rtl ? -p : p) + 'px');
    };

    // splide's `is-active` on the current slide (Slides.update) - read by behave-collection-linea-strip.json.
    Strip.prototype.mark = function () {
      var i = this.index;
      Array.prototype.forEach.call(this.track.children, function (li, k) {
        li.classList.toggle('is-active', k === i);
      });
    };

    Strip.prototype.exceeded = function () {
      return this.pos > 0 || this.pos < -this.limit;
    };

    // Where the list is drawn right now (mid-glide the transform, not the target).
    Strip.prototype.current = function () {
      var li = this.track.firstElementChild;
      var m = li && window.getComputedStyle(li).transform;
      if (!m || m === 'none') return this.pos;
      var x = new DOMMatrixReadOnly(m).m41;
      return this.rtl ? -x : x;
    };

    Strip.prototype.base = function (e) {
      this.baseX = e.pageX;
      this.baseT = e.timeStamp;
      this.from = this.pos;
    };

    // `N` (pointer down): a list already moving is taken as it is, and drags at once.
    Strip.prototype.down = function (e) {
      if (e.button > 0 || this.pointerId !== undefined) return;
      var moving = this.track.classList.contains('is-going');
      if (moving) this.set(this.current(), false);
      this.started = moving;
      this.over = this.exceeded();
      this.pointerId = e.pointerId;
      this.touch = e.pointerType === 'touch';
      this.downX = e.pageX;
      this.downY = e.pageY;
      this.base(e);
      window.addEventListener('pointermove', this.onMove);
      window.addEventListener('pointerup', this.onUp);
      window.addEventListener('pointercancel', this.onUp);
    };

    // `A` (pointer move): horizontal and past the threshold (touch 10, mouse 0) starts the drag; beyond an end the
    // finger moves the list a fifth; the base moves every 200ms or when the list crosses an end.
    Strip.prototype.move = function (e) {
      if (e.pointerId !== this.pointerId) return;
      var dir = this.rtl ? -1 : 1;
      if (!this.started) {
        var dx = e.pageX - this.downX;
        var dy = e.pageY - this.downY;
        if (Math.abs(dx) <= Math.abs(dy)) return;
        this.started = Math.abs(dx) > (this.touch ? 10 : 0);
        if (e.cancelable) e.preventDefault();
        return;
      }
      this.set(this.from + ((e.pageX - this.baseX) * dir) / (this.over ? 5 : 1), false);
      var stale = e.timeStamp - this.baseT > 200;
      var flipped = this.over !== (this.over = this.exceeded());
      if (stale || flipped) this.base(e);
      this.dragged = true;
      if (e.cancelable) e.preventDefault();
    };

    Strip.prototype.release = function () {
      window.removeEventListener('pointermove', this.onMove);
      window.removeEventListener('pointerup', this.onUp);
      window.removeEventListener('pointercancel', this.onUp);
      this.pointerId = undefined;
    };

    // `_` (pointer up): velocity over the last base (< 200ms, and not beyond an end), destination = pos + sign(v) *
    // min(|v| * flickPower, list size), then the nearest card (`toDest`) at speed 400.
    Strip.prototype.up = function (e) {
      if (e.pointerId !== this.pointerId) return;
      this.release();
      if (!this.started) return;
      var dir = this.rtl ? -1 : 1;
      var dt = e.timeStamp - this.baseT;
      var v = !this.over && dt && dt < 200 ? ((e.pageX - this.baseX) * dir) / dt : 0;
      var dest = this.pos + Math.sign(v) * Math.min(Math.abs(v) * 200, this.size);
      var best = 0;
      var min = Infinity;
      for (var k = 0; k < this.offsets.length; k++) {
        var d = Math.abs(this.posOf(k) - dest);
        if (d < min) {
          min = d;
          best = k;
        }
      }
      this.index = best;
      this.mark();
      var target = this.posOf(best);
      this.set(target, Math.abs(target - this.pos) > 0.5);
      this.started = false;
      if (this.dragged) {
        this.preventClick = true;
        var self = this;
        setTimeout(function () {
          self.preventClick = false;
          self.dragged = false;
        });
      }
    };

    function init(scope) {
      (scope || document).querySelectorAll('.clstrip__track').forEach(function (t) {
        if (t.clstrip) return;
        t.clstrip = new Strip(t);
      });
    }

    init();
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-linea"] && !Shopify.designMode) return;
  try {
    
  // כפתורי התצוגה של linea מחליפים את מספר הטורים; המיון מנווט.
  (function () {
    var roots = document.querySelectorAll('.clin');
    roots.forEach(function (root) {
      var grid = root.querySelector('[data-clin-grid]');
      root.querySelectorAll('[data-clin-view]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!grid) return;
          grid.setAttribute('data-clin-cols', btn.getAttribute('data-clin-view'));
          var group = btn.closest('.clin__view');
          group.querySelectorAll('[data-clin-view]').forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            if (on) b.setAttribute('aria-pressed', 'true'); else b.removeAttribute('aria-pressed');
          });
        });
      });
      // 🚨 אנימציית הכניסה — `onIntersection` של המקור (`animations.js`), Theme 112.0:
      // מחוץ לתצוגה -> `is-offscreen` (מוסתר, האנימציה לא רצה); נכנס, והיה מוסתר -> מסירים, ואם יש
      // `data-clin-cascade` הסדר הוא המקום במנה של המשקיף (כמו `--animation-order: ${index}`).
      // מה שבתצוגה בטעינה לא סומן מעולם ושומר את הסדר מהשרת (1..N, כמו במקור). שוליים -20 כמו במקור.
      // **אין הסתרה מראש** — בלי JS / בלי משקיף האנימציה רצה מה-CSS והכול נראה.
      // הבדל ידוע ורשום: במקור משקיף אחד לכל העמוד, אצלנו לסקשן.
      var anim = root.querySelectorAll('[data-clin-anim]');
      if (anim.length && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e, index) {
            var el = e.target;
            if (e.isIntersecting) {
              if (el.classList.contains('is-offscreen')) {
                el.classList.remove('is-offscreen');
                if (el.hasAttribute('data-clin-cascade')) el.style.setProperty('--clin-order', index);
              }
              io.unobserve(el);
            } else {
              el.classList.add('is-offscreen');
            }
          });
        }, { rootMargin: '0px 0px -20px 0px' });
        anim.forEach(function (el) { io.observe(el); });
      }

      // 🚨 עיגולי הגוון. עד 6.9.2026 היו `span` בלי שום מאזין.
      root.querySelectorAll('.clin__swatches').forEach(function (group) {
        var card = group.closest('.clin__card');
        if (!card) return;
        var links = card.querySelectorAll('.clin__media, .clin__title');
        var img = card.querySelector('.clin__media img');
        var pick = function (sw) {
          group.querySelectorAll('[data-clin-swatch]').forEach(function (s) {
            s.setAttribute('aria-pressed', s === sw ? 'true' : 'false');
          });
          if (sw.dataset.swatchUrl) {
            links.forEach(function (a) { a.setAttribute('href', sw.dataset.swatchUrl); });
          }
          // ⚠️ ריק היום: לאף גרסה בחנות אין תמונה משלה. נמדד ב-API 6.9.
          if (img && sw.dataset.swatchImg) {
            img.removeAttribute('srcset');
            img.src = sw.dataset.swatchImg;
          }
        };
        group.querySelectorAll('[data-clin-swatch]').forEach(function (sw) {
          sw.addEventListener('click', function () { pick(sw); });
          sw.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(sw); }
          });
        });
      });

      // שני תפריטי מיון: בשורת הכלים (1024+) ובמגירה.
      root.querySelectorAll('[data-clin-sort]').forEach(function (sort) {
        sort.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          window.location.href = url.toString();
        });
      });

      // 🚨 המגירה מתחת ל-1024 (Theme 100.0). במקור: הפוקוס נשאר על הכפתור, Tab ממשיך
      // לסגירה; סגירה באיקס, ב-Escape, ב-"Apply" ובלחיצה על השכבה; הגוף `overflow: hidden`
      // כשהיא פתוחה. `review-cl-100/both-ref-390.txt` (עם השכבה — `keep`).
      var drawer = root.querySelector('[data-clin-drawer]');
      var opener = root.querySelector('[data-clin-drawer-open]');
      var overlay = root.querySelector('[data-clin-drawer-overlay]');
      var ownLock = false;
      if (drawer && opener) {
        var setOpen = function (on) {
          var was = drawer.classList.contains('is-open');
          drawer.classList.toggle('is-open', on);
          if (overlay) overlay.classList.toggle('is-open', on);
          if (was && !on) opener.focus();
          opener.setAttribute('aria-expanded', on ? 'true' : 'false');
          document.body.style.overflow = on ? 'hidden' : '';
          // מ-990 הדף גולל בתוך `.page-wrapper` — הנעילה של הערכה, ורק אם אנחנו הוספנו אותה.
          var html = document.documentElement;
          if (on && !was) { ownLock = !html.hasAttribute('scroll-lock'); html.setAttribute('scroll-lock', ''); }
          if (!on && was) { if (ownLock) html.removeAttribute('scroll-lock'); ownLock = false; }
          // המסננים נכנסים ב-fade כשהם בתצוגה; מחוץ למסך המשקיף לא יורה.
          if (on) drawer.querySelectorAll('[data-clin-anim]').forEach(function (el) {
            el.classList.remove('is-offscreen'); el.classList.add('is-in');
          });
        };
        opener.addEventListener('click', function () { setOpen(true); });
        drawer.querySelectorAll('[data-clin-drawer-close]').forEach(function (b) {
          b.addEventListener('click', function () { setOpen(false); });
        });
        if (overlay) overlay.addEventListener('click', function () { setOpen(false); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
        });
        // כמו `ComponentDrawer` במקור: פוקוס שיוצא מהמגירה כשהיא פתוחה חוזר לסגירה
        // (ולכן Tab מהכפתור נכנס אליה), ובסגירה הפוקוס חוזר לכפתור שפתח.
        var closeBtn = drawer.querySelector('.clin__dclose');
        document.addEventListener('focus', function (e) {
          if (drawer.classList.contains('is-open') && e.target !== opener && !drawer.contains(e.target) && closeBtn) {
            e.stopPropagation(); closeBtn.focus();
          }
        }, true);
        // מעל 1023 אין מגירה — לא להשאיר את הגוף נעול אם החלון גדל.
        var wide = window.matchMedia('(min-width: 1024px)');
        var onWide = function () { if (wide.matches && drawer.classList.contains('is-open')) setOpen(false); };
        if (wide.addEventListener) wide.addEventListener('change', onWide);
      }

      // קבוצת מסנן — העתקה של `CollapsibleDetails` במקור (`review-cl-100/source-js/theme.js`):
      // שני פריימים, ואז `is-open`, הגובה והתוכן (16px) יחד; בסוף הסגירה `open` יורד.
      // לחיצה באמצע תנועה נרשמת ומבוצעת בסופה.
      root.querySelectorAll('.clin__facet').forEach(function (det) {
        var summary = det.querySelector('.clin__facet-summary');
        var wrap = det.querySelector('.clin__facet-wrap');
        var content = det.querySelector('.clin__facet-body');
        if (!summary || !wrap || !content) return;
        var busy = false, pending, raf;
        var openIt = function () {
          busy = true; det.open = true; cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var h = content.scrollHeight;
            wrap.style.height = '0px'; content.style.transform = 'translateY(16px)';
            raf = requestAnimationFrame(function () {
              det.classList.add('is-open'); wrap.style.height = h + 'px'; content.style.transform = 'translateY(0)';
            });
          });
        };
        var closeIt = function () {
          busy = true; cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            wrap.style.height = wrap.scrollHeight + 'px';
            raf = requestAnimationFrame(function () {
              det.classList.remove('is-open'); wrap.style.height = '0px'; content.style.transform = 'translateY(16px)';
            });
          });
        };
        // בלי תנועה אין `transitionend` — הקבוצה נפתחת ונסגרת מיד.
        var still = window.matchMedia('(prefers-reduced-motion: reduce)');
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (still.matches) {
            var on = !det.classList.contains('is-open');
            det.open = on; det.classList.toggle('is-open', on);
            wrap.style.height = on ? 'auto' : '0px'; content.style.transform = on ? '' : 'translateY(16px)';
            return;
          }
          if (busy) { pending = !det.open; return; }
          if (det.open) closeIt(); else openIt();
        });
        wrap.addEventListener('transitionend', function (e) {
          if (e.propertyName !== 'height' || e.target !== wrap) return;
          busy = false;
          if (det.classList.contains('is-open')) wrap.style.height = 'auto'; else det.open = false;
          if (pending !== undefined) { var next = pending; pending = undefined; if (next) openIt(); else closeIt(); }
        });
      });

      // 🚨 הטופס לא נשלח מעולם. סימון תיבת מסנן לא עשה כלום —
      // בדיוק "לחצתי ולא קרה כלום". נמדד 6.9.2026.
      var form = root.querySelector('.clin__facets-form');
      if (form) {
        var submit = function () {
          // שדה ריק אינו נשלח, אחרת הכתובת מתמלאת בפרמטרים ריקים.
          form.querySelectorAll('input').forEach(function (i) {
            if (i.type !== 'checkbox' && i.value === '') i.disabled = true;
          });
          form.submit();
        };
        form.addEventListener('change', function (e) {
          if (e.target.closest('.clin__facet-input, .clin__field-input')) submit();
        });

        // המחוון הגורר. שתי ידיות על אותו פס, ובעברית הן נמדדות מימין.
        form.querySelectorAll('[data-clin-pf]').forEach(function (sl) {
          var max = parseFloat(sl.getAttribute('data-pf-max')) || 0;
          if (!max) return;
          var track = sl.querySelector('.clin__pf-range');
          var fields = sl.parentElement.querySelectorAll('.clin__field-input');
          var lo = fields[0], hi = fields[1];
          var clamp = function (v) { return Math.min(1, Math.max(0, v)); };

          var paint = function () {
            var a = clamp((parseFloat(lo.value) || 0) / max);
            var b = clamp(lo.value === '' && hi.value === '' ? 1 : (parseFloat(hi.value) || max) / max);
            if (a > b) a = b;
            sl.style.setProperty('--pf-a', a);
            sl.style.setProperty('--pf-b', b);
            sl.querySelectorAll('[data-clin-pf-handle]').forEach(function (h) {
              var which = h.getAttribute('data-clin-pf-handle');
              h.setAttribute('aria-valuenow', Math.round((which === 'min' ? a : b) * max));
            });
          };
          paint();
          lo.addEventListener('input', paint);
          hi.addEventListener('input', paint);

          sl.querySelectorAll('[data-clin-pf-handle]').forEach(function (h) {
            var which = h.getAttribute('data-clin-pf-handle');
            var field = which === 'min' ? lo : hi;

            var at = function (clientX) {
              var r = track.getBoundingClientRect();
              // ⚠️ בעברית הפס רץ מימין לשמאל. `inset-inline-start` נמדד
              // מהקצה הימני, ולכן החישוב מתהפך יחד עם כיוון הדף.
              var rtl = getComputedStyle(track).direction === 'rtl';
              var f = rtl ? (r.right - clientX) / r.width : (clientX - r.left) / r.width;
              return Math.round(clamp(f) * max);
            };

            var move = function (e) {
              var v = at(e.clientX);
              var other = which === 'min' ? parseFloat(hi.value || max) : parseFloat(lo.value || 0);
              if (which === 'min') v = Math.min(v, other); else v = Math.max(v, other);
              field.value = v;
              paint();
            };
            var up = function () {
              document.removeEventListener('pointermove', move);
              document.removeEventListener('pointerup', up);
              submit();
            };
            h.addEventListener('pointerdown', function (e) {
              e.preventDefault();
              document.addEventListener('pointermove', move);
              document.addEventListener('pointerup', up);
            });
            h.addEventListener('keydown', function (e) {
              var step = e.key === 'ArrowRight' || e.key === 'ArrowUp' ? 1
                       : e.key === 'ArrowLeft' || e.key === 'ArrowDown' ? -1 : 0;
              if (!step) return;
              e.preventDefault();
              field.value = Math.round(clamp(((parseFloat(field.value) || (which === 'min' ? 0 : max)) + step * max / 100) / max) * max);
              paint();
            });
            h.addEventListener('keyup', function (e) {
              if (e.key.indexOf('Arrow') === 0) submit();
            });
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-noom"] && !Shopify.designMode) return;
  try {
    
  // מתג צפיפות הרשת, וכפתור המסננים שהופך למרחף אחרי גלילה בנייד.
  // שני המצבים נמדדו במקור לפני שנכתבה שורה כאן.
  (function () {
    var root = document.querySelector('[data-cnoom]');
    if (!root) return;

    var grid = root.querySelector('[data-cnoom-grid]');
    root.querySelectorAll('[data-cnoom-density]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-cnoom-density]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        if (grid) grid.style.setProperty('--cnoom-per-row', btn.dataset.cnoomDensity);
      });
    });

    // 🚨 עיגולי הגוון. עד 6.9.2026 הם היו כפתורים בלי שום מאזין —
    // ארבעה עיגולים כפול חמישה כרטיסים שלא עשו כלום.
    root.querySelectorAll('[data-cnoom-swatches]').forEach(function (group) {
      var card = group.closest('.cnoom__card');
      if (!card) return;
      var links = card.querySelectorAll('.cnoom__card-main, .cnoom__card-title');
      var img = card.querySelector('.cnoom__card-main img');
      group.querySelectorAll('[data-cnoom-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          group.querySelectorAll('[data-cnoom-swatch]').forEach(function (s) {
            s.classList.remove('is-active');
            s.setAttribute('aria-pressed', 'false');
          });
          sw.classList.add('is-active');
          sw.setAttribute('aria-pressed', 'true');
          // הקישור נושא את הגוון הלאה, ולכן הכרטיס נוחת על הגרסה הנכונה.
          if (sw.dataset.swatchUrl) {
            links.forEach(function (a) { a.setAttribute('href', sw.dataset.swatchUrl); });
          }
          // ⚠️ ריק היום: לאף גרסה בחנות אין תמונה משלה. נמדד ב-API.
          // ברגע שתהיה אחת, השורה הזאת מחליפה את התמונה כמו במקור.
          if (img && sw.dataset.swatchImg) {
            img.removeAttribute('srcset');
            img.src = sw.dataset.swatchImg;
          }
        });
      });
    });

    // 🚨 **`.page-wrapper` קיים בעמוד הזה ואינו זה שגולל.**
    // סעיף ג אומר שהערכה גוללת במכל פנימי, וזה נכון בחלק
    // מהעמודים. כאן נמדד: אחרי גלגלת `window.scrollY` הוא 1531
    // ו-`.page-wrapper.scrollTop` נשאר 0.
    //
    // ⚠️ **הגרסה הראשונה בחרה את המכל רק כי הוא קיים, והמאזין
    // מעולם לא נורה.** הכפתור פשוט לא הפך מרחף, בלי שגיאה.
    // **קיום אינו שימוש** — מאזינים לשניהם וקוראים את מי שזז.
    // פתיחת המגירה וסגירתה. הכפתור פותח בשני הרוחבים, גם כשהוא מרחף.
    var drawer = root.querySelector('[data-cnoom-drawer]');
    var btn = root.querySelector('[data-cnoom-filters]');
    if (drawer && btn) {
      btn.addEventListener('click', function () { drawer.hidden = false; });
      drawer.querySelector('[data-cnoom-drawer-close]')?.addEventListener('click', function () { drawer.hidden = true; });
      // לחיצה על הרקע סוגרת, ו-Escape סוגר. שניהם במקור.
      drawer.addEventListener('click', function (e) { if (e.target === drawer) drawer.hidden = true; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer.hidden = true; });
    }

    if (!btn) return;
    var wrapper = document.querySelector('.page-wrapper');

    function scrolledBy() {
      var a = window.scrollY || document.documentElement.scrollTop || 0;
      var b = wrapper ? wrapper.scrollTop : 0;
      return a > b ? a : b;
    }

    function onScroll() {
      /* 🚨 **991 ולא 749. 6.9.2026, לילה.** 749 הוא נקודת השבירה של
         Tinker — פריט 17 — והוא ישב כאן ב-JS, בדיוק המקום שגריפת
         `sections/*.liquid` ו-`breakpoints.mjs` אינם מסתכלים בו.
         סעיף קפו 5ב, אותה משפחה כמו `bundle-builder`.

         **וזו התשובה לשאלה שסעיף קצג 3 השאיר פתוחה:** *"האם הכיתה
         `is-floating` נמצאת על הכפתור ב-879 בזמן המדידה."* **לא** —
         השורה הזאת הסירה אותה בכל רוחב מעל 749, **ולכן הכלל
         `.is-floating svg { margin-inline-end: 0 }` מעולם לא חל שם.**
         שני ניסיונות קודמים חיפשו ספציפיות ומשטר, והמנגנון היה כאן.

         **הגבול 992 נמדד ולא נוחש**, משני כיוונים בלתי תלויים:
           1. עמודת "ציפי" ב-13 רוחבים: המקור מרחף עד 991 ונח מ-992.
              991 ו-992 שכנים במיפוי, וזה גבול על פיקסל.
           2. בגיליון של המקור יש כלל ייעודי
              `@media(min-width:768px) .product-filters__open-menu-button.is-fixed
               { top: calc(--header-height + --header-offset-top + 16px); bottom: auto }`
              — **כלל למצב שלא היה קורה מעולם אם המקור לא היה מרחף
              מעל 768.** */
      /* 🚨🚨 **7.9.2026 — הכלל של המקור נקרא מהסקריפט שלו, ואין בו רוחב
         בכלל. סעיף רא 1.** `component-product-filters.build.min.js`:

           A(wrapper, W, Q, { rootMargin: `-${headerH}px 0px 0px 0px` })
           W: opener.classList.remove('is-fixed'); wrapper.style.minHeight='auto'
           Q: if (X(wrapper)) return;
              wrapper.style.minHeight = wrapper.offsetHeight + 'px';
              opener.classList.add('is-fixed')
           X: wrapper.offsetTop + wrapper.offsetHeight >= pageYOffset + headerH

         כלומר **`IntersectionObserver` על שורת הכפתור**: הוא נעשה מרחף
         כשהשורה שלו יוצאת מעל הכותרת הדביקה, **וחוזר למנוחה כשהיא
         נראית שוב.** שלושה הפרשים מול מה שכתוב כאן — אין שער רוחב, אין
         סף 100, **והמקור כן חוזר למנוחה.**

         ⚠️ **וההערה שהייתה כאן טענה את ההפך וטענה שנמדד:** *"במקור הוא
         אינו חוזר להיות רגיל אחרי שהפך מרחף, נמדד בשלושה מצבים."*
         **הקוד של המקור אומר אחרת.** פריט 18.

         ⏸ **ולא שיניתי, וזו הכרעה של אלעד ולא עצלות. סעיף רא 5:**
         `compare-ref` גולל למטה **וחוזר למעלה** לפני שהוא מודד, ולכן
         כפתור שחוזר למנוחה יימדד במנוחה — **והמפרט מצפה למרחף ב-359 עד
         991.** כלומר נאמנות למקור מול כארבעים בדיקות ירוקות, **ואין
         מדידה שמכריעה, כי המדד עצמו הוא זה שגולל.** ⛔ **ובאזור הזה
         כבר נשרפו שלושה ניסיונות — חוק 1.** */
      if (window.innerWidth > 991) {
        btn.classList.remove('is-floating');
        return;
      }
      if (scrolledBy() > 100) btn.classList.add('is-floating');
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-linea"] && !Shopify.designMode) return;
  try {
    
  // לחיצה על נקודה מחליפה את הכרטיס שבעמודה, כמו במקור:
  // `.thumbnail-item.is-active` מסמנת את הנקודה, והסליידר עובר לשקופית.
  (function () {
    document.querySelectorAll('.hlin').forEach(function (root) {
      // 🚨 עיגולי הגוון בכרטיס. עד 6.9.2026 בלי שום מאזין.
      root.querySelectorAll('.hlin__swatches').forEach(function (group) {
        var card = group.closest('.hlin__card');
        if (!card) return;
        var links = card.querySelectorAll('.hlin__card-link, .hlin__card-title');
        var img = card.querySelector('.hlin__card-img');
        var pick = function (sw) {
          group.querySelectorAll('[data-hlin-swatch]').forEach(function (s) {
            s.setAttribute('aria-pressed', s === sw ? 'true' : 'false');
          });
          if (sw.dataset.swatchUrl) {
            links.forEach(function (a) { a.setAttribute('href', sw.dataset.swatchUrl); });
          }
          if (img && sw.dataset.swatchImg) {
            img.removeAttribute('srcset');
            img.src = sw.dataset.swatchImg;
          }
        };
        group.querySelectorAll('[data-hlin-swatch]').forEach(function (sw) {
          sw.addEventListener('click', function () { pick(sw); });
          sw.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(sw); }
          });
        });
      });

      var dots = root.querySelectorAll('[data-hlin-dot]');
      var slider = root.querySelector('[data-hlin-slider]');
      var track = root.querySelector('[data-hlin-track]');
      if (!slider || !track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-hlin-card]'));
      var N = cards.length;
      if (!N) return;

      // Theme 101.0 — אלעד 25.9 (*"6:2"*): הנקודות ניווט + החצים של המקור. מ-641: splide `loop`, כרטיס אחד, 400ms
      // `cubic-bezier(.25,1,.5,1)` (review-hl-101/arrows-src.txt); עד 640: שני כרטיסים בגלילה. הנקודה הפעילה עוקבת
      // אחרי הכרטיס (במקור `.thumbnail-item.is-active` זז עם החץ). בתנועה מופחתת — בלי מעבר (ברירת המחדל של splide).
      var fill = root.querySelector('[data-hlin-progress]');
      var rtl = getComputedStyle(root).direction === 'rtl';
      var sign = rtl ? 1 : -1;
      var wide = window.matchMedia('(min-width: 641px)');
      var still = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (fill) fill.style.transformOrigin = rtl ? '100% 50%' : '0 50%';

      // עותק של האחרון לפני הראשון ושל הראשון אחרי האחרון — הלולאה עוברת אליהם בתנועה וקופצת חזרה בלי.
      if (N > 1) {
        var clone = function (c) {
          var k = c.cloneNode(true);
          k.setAttribute('data-hlin-clone', '');
          k.removeAttribute('data-hlin-card');
          k.setAttribute('aria-hidden', 'true');
          k.setAttribute('inert', '');
          // מחלקה משלו ולא `hlin__card`: כל בורר "הכרטיס הראשון" (behave, compare-ref) היה תופס את העותק המוסתר.
          k.className = 'hlin__clone';
          // וגם בתוכו: בלי מזהים ובלי `data-hlin-swatch`, כדי ש"הגוון הראשון" / `id` לא יפלו על העותק.
          k.querySelectorAll('[id]').forEach(function (e) { e.removeAttribute('id'); });
          k.querySelectorAll('[data-hlin-swatch]').forEach(function (e) { e.removeAttribute('data-hlin-swatch'); });
          return k;
        };
      }
      // העותקים קיימים רק מ-641, שם יש לולאה. עד 640 הם היו בדף מוסתרים — וכל מדידה של "תמונת הכרטיס הראשונה" קראה 0
      // (compare-ref 786/810, `review-hl-101/cmp-dev.txt`).
      var clones = function (on) {
        track.querySelectorAll('.hlin__clone').forEach(function (k) { k.remove(); });
        if (on && N > 1) {
          track.insertBefore(clone(cards[N - 1]), cards[0]);
          track.appendChild(clone(cards[0]));
        }
      };

      var index = 0;
      var busy = false;
      // 217.0 (Home 24 report 190, Head 97.0): under the site's html zoom getBoundingClientRect / clientX are DRAWN px while translateX
      // and trackX() are LAYOUT px - every drawn value goes through zf() (MDN Element.currentCSSZoom; 1 where it is missing / no zoom).
      var zf = function (el) { return el.currentCSSZoom || 1; };
      var step = function () {
        return cards[0].getBoundingClientRect().width / zf(cards[0]) + (parseFloat(getComputedStyle(track).columnGap) || 0);
      };
      var place = function (k, animate) {
        track.style.transition = animate && !still.matches ? 'transform 400ms cubic-bezier(0.25, 1, 0.5, 1)' : 'none';
        track.style.transform = 'translateX(' + sign * (k + (N > 1 ? 1 : 0)) * step() + 'px)';
      };
      // sliding = true בזמן מעבר: הכרטיס היוצא נשאר לחיץ עד סוף המעבר (במקור לחיצה עליו פותחת אותו), ונחתם ב-transitionend.
      var mark = function (i, sliding) {
        dots.forEach(function (d) {
          var on = Number(d.getAttribute('data-hlin-dot')) === i;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        // Theme 136.0 (HL1): מ-641 רק הכרטיס המוצג נגיש. ‏במקור splide שם `tabindex="-1"` על הקישורים / הגוונים של שאר
        // השקופיות ו-`aria-hidden` עליהן; אצלנו Tab לכרטיס מוסתר גלל את המסילה החתוכה, והחץ השאיר עמודה ריקה (LEARNED תתנז).
        // ‏`inert` מוציא אותם מה-Tab ומקורא המסך יחד. ‏קישור התמונה של הכרטיס המוצג = עצירה, כמו `a.product-link` במקור.
        // ‏עד 640 (מסילה נגללת, כמה כרטיסים במסך) — כמו היום.
        cards.forEach(function (c, k) {
          var on = k === i;
          var hide = wide.matches && !on;
          c.classList.toggle('is-active', on);
          if (sliding && hide && !c.hasAttribute('inert')) return;
          c.toggleAttribute('inert', hide);
          if (hide) c.setAttribute('aria-hidden', 'true'); else c.removeAttribute('aria-hidden');
          var a = c.querySelector('.hlin__card-link');
          if (!a) return;
          if (wide.matches && on) { a.setAttribute('tabindex', '0'); a.removeAttribute('aria-hidden'); }
          else { a.setAttribute('tabindex', '-1'); a.setAttribute('aria-hidden', 'true'); }
        });
      };
      var setFill = function (f) { if (fill) fill.style.transform = 'scaleX(' + f + ')'; };

      var go = function (k) {
        if (!wide.matches) {
          // עד 640: גלילה לכרטיס (העמוד שלו), הפס והנקודה מתעדכנים מהגלילה.
          var c = cards[(k + N) % N];
          pinned = (k + N) % N;
          mark(pinned);
          var sr = slider.getBoundingClientRect(), cr = c.getBoundingClientRect();
          // 102.0: המסילה נמתחת לקצה המסך ומחזירה 24 בריפוד — הכרטיס מיושר לתחילת התוכן, לא לקצה המסילה.
          var pad = parseFloat(getComputedStyle(slider).paddingInlineStart) || 0;
          slider.scrollBy({ left: rtl ? cr.right - (sr.right - pad) : cr.left - (sr.left + pad), behavior: still.matches ? 'auto' : 'smooth' });
          return;
        }
        if (busy && !still.matches) return;
        busy = true;
        place(k, true);
        index = (k + N) % N;
        mark(index, !still.matches);
        setFill((index + 1) / N);
        if (still.matches) { place(index, false); busy = false; }
      };
      // 136.0 (HL1d): גם transitioncancel — שינוי רוחב באמצע מעבר מבטל אותו, ובלי זה `busy` נשאר דלוק (החצים מתו עד רענון)
      // והכרטיס היוצא לא נחתם.
      var settle = function (e) {
        if (e.target !== track) return;
        busy = false;
        place(index, false);
        mark(index);
      };
      track.addEventListener('transitionend', settle);
      track.addEventListener('transitioncancel', settle);

      // Theme 136.0 (HL2): גרירה מ-641 — האלגוריתם של ה-Drag של splide v4 במקור, מהקוד שלו (`review-136/hl/g2/src-splide.js`,
      // ‏FINDINGS HL2): מתחילים כשהתזוזה אופקית יותר מאנכית ומעל הסף (עכבר 0 / אצבע 10), והאירוע שמתחיל אינו מזיז; המסילה
      // עוקבת 1:1 מ"נקודת בסיס" שמתאפסת כל 200ms; בשחרור — מהירות = מרחק מהבסיס / זמן מהבסיס אם פחות מ-200ms, אחרת 0;
      // היעד = המיקום + סימן × min(|מהירות| × 600, רוחב העמודה) ← הכרטיס הקרוב (עד אחד מהנוכחי) דרך go(), או חזרה.
      // גרירת עכבר בולעת את הלחיצה הבאה פעם אחת; באצבע לא — הדפדפן מחליט, כמו במקור (FINDINGS: 12/15px עוד פותח).
      var drag = null;
      var swallow = false;
      var trackX = function () { return new DOMMatrixReadOnly(getComputedStyle(track).transform).m41; };
      slider.addEventListener('pointerdown', function (e) {
        swallow = false;
        if (!wide.matches || busy || N < 2 || (e.pointerType === 'mouse' && e.button !== 0)) return;
        drag = { id: e.pointerId, type: e.pointerType, on: false, bt: e.timeStamp, bx: e.clientX, by: e.clientY, pos: trackX(), z: zf(track) };
      });
      slider.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.bx;
        if (!drag.on) {
          if (Math.abs(dx) <= Math.abs(e.clientY - drag.by)) return;
          if (Math.abs(dx) <= (drag.type === 'mouse' ? 0 : 10)) return;
          drag.on = true;
          track.style.transition = 'none';
          slider.classList.add('is-dragging');
          var sel = window.getSelection && window.getSelection();
          if (sel) sel.removeAllRanges();
          try { slider.setPointerCapture(e.pointerId); } catch (err) {}
          return;
        }
        track.style.transform = 'translateX(' + (drag.pos + dx / drag.z) + 'px)';
        if (e.timeStamp - drag.bt > 200) { drag.bt = e.timeStamp; drag.bx = e.clientX; drag.pos = trackX(); }
      });
      var release = function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var g = drag;
        drag = null;
        if (!g.on) return;
        slider.classList.remove('is-dragging');
        if (g.type === 'mouse') swallow = true;
        var dt = e.timeStamp - g.bt;
        var v = dt > 0 && dt < 200 ? (e.clientX - g.bx) / g.z / dt : 0;
        var w = step();
        var dest = trackX() + (v > 0 ? 1 : v < 0 ? -1 : 0) * Math.min(Math.abs(v) * 600, slider.clientWidth);
        // the track sits at sign x (index + 1) x step: the nearest card to `dest`, at most one from the current
        var delta = Math.max(-1, Math.min(1, Math.round(dest / (sign * w)) - 1 - index));
        var k = index + delta;
        // already there (or reduced motion): no transition would run -> no transitionend -> `busy` would stay on. Land directly.
        if (still.matches || Math.abs(trackX() - sign * (k + 1) * w) < 0.5) {
          index = (k + N) % N;
          place(index, false);
          mark(index);
          setFill((index + 1) / N);
          return;
        }
        if (delta) { go(k); return; }
        busy = true;
        place(index, true);
      };
      slider.addEventListener('pointerup', release);
      slider.addEventListener('pointercancel', release);
      slider.addEventListener('click', function (e) {
        if (!swallow) return;
        swallow = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
      slider.addEventListener('dragstart', function (e) { if (wide.matches) e.preventDefault(); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = Number(dot.getAttribute('data-hlin-dot')) || 0;
          if (i !== index || !wide.matches) go(i);
        });
      });
      var prev = root.querySelector('[data-hlin-prev]');
      var next = root.querySelector('[data-hlin-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });

      // עד 640: העמוד מהגלילה — שני כרטיסים לעמוד, N-1 עמודים, המילוי (עמוד+1)/(N-1) כמו במקור (0.5 → 1 בשלושה).
      var pages = Math.max(1, N - 1);
      // נקודה שנלחצה נשארת דלוקה כל עוד העמוד שלה על המסך (כרטיס 3 חולק עמוד עם 2 — בלי זה נדלקה נקודה 2).
      var pinned = null;
      var onScroll = function () {
        if (wide.matches) return;
        var st = cards.length > 1 ? cards[1].getBoundingClientRect().width + (parseFloat(getComputedStyle(slider).columnGap) || 0) : 1;
        var page = Math.min(pages - 1, Math.round(Math.abs(slider.scrollLeft) / st));
        setFill((page + 1) / pages);
        index = page;
        if (pinned !== null) { if (Math.min(pinned, pages - 1) === page) mark(pinned); return; }
        mark(page);
      };
      slider.addEventListener('scroll', onScroll, { passive: true });
      // גלילה של הגולש משחררת את הנקודה שנלחצה; הגלילה שהנקודה עצמה התחילה — לא.
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (t) {
        slider.addEventListener(t, function () { pinned = null; }, { passive: true });
      });

      var reset = function () {
        clones(wide.matches);
        if (wide.matches) { place(index, false); setFill((index + 1) / N); mark(index); }
        else {
          track.style.transform = ''; track.style.transition = '';
          // 136.0 (HL1b): עד 640 כל הכרטיסים נגישים — משחררים כאן ולא סומכים על onScroll, שחוזר בלי mark() כשנקודה "נעוצה".
          cards.forEach(function (c) {
            c.removeAttribute('inert'); c.removeAttribute('aria-hidden');
            var a = c.querySelector('.hlin__card-link');
            if (a) { a.setAttribute('tabindex', '-1'); a.setAttribute('aria-hidden', 'true'); }
          });
          onScroll();
        }
      };
      wide.addEventListener('change', reset);
      window.addEventListener('resize', function () { if (wide.matches) place(index, false); });
      reset();
    });
  })();

  // Theme 111.0 — חשיפה בגלילה כמו `animations.js` של המקור: ‏IntersectionObserver עם `rootMargin: 0px 0px -20px 0px`;
  // אלמנט שנכנס מקבל `--hlin-order` = מקומו במנה (`data-cascade` במקור) ונחשף פעם אחת. נצפים רק התמונה והכרטיסים
  // האמיתיים, בסדר הזה — כמו במקור, שם העותקים של הלולאה נוצרים אחרי האתחול ואינם נצפים.
  (function () {
    document.querySelectorAll('.hlin').forEach(function (root) {
      // מצבי המקור: בלי ערך = רץ (כמו בלי `--offscreen`) · `off` = מוסתר וממתין · `in` = נחשף. ‏הקריאה הראשונה של המשקיף
      // "מחמשת" את מה שמחוץ לתצוגה (`off`), ומה שבתוכה ממשיך לרוץ — בדיוק `onIntersection` של המקור.
      var els = root.querySelectorAll('[data-hlin-reveal]:not([data-hlin-clone])');
      if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) return;
      // העותקים של הלולאה נוצרים לפני המשקיף ואינם נצפים; במקור הם מועתקים אחרי שהמקוריים כבר `--offscreen` ונשארים כך.
      root.querySelectorAll('[data-hlin-clone][data-hlin-reveal]').forEach(function (k) { k.setAttribute('data-hlin-reveal', 'off'); });
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en, i) {
          var e = en.target;
          if (en.isIntersecting) {
            if (e.getAttribute('data-hlin-reveal') === 'off') {
              e.style.setProperty('--hlin-order', i);
              e.setAttribute('data-hlin-reveal', 'in');
            }
            obs.unobserve(e);
          } else {
            e.setAttribute('data-hlin-reveal', 'off');
          }
        });
      }, { rootMargin: '0px 0px -20px 0px' });
      els.forEach(function (e) { io.observe(e); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendations-inova"] && !Shopify.designMode) return;
  try {
    
  // 🚨 גלריית הריחוף על תמונת הכרטיס — עותק של #9a בסקשן 2 (`shop-the-look-inova.liquid`, "גלריית הריחוף"), מילה
  // במילה בחשבון, בקידומת `reci__`. במקור `SecondaryMedia` (theme.js) על flickity. ההבדל היחיד: כאן **רכיב**
  // (`<reci-gallery>`) ולא סריקה אחת בטעינה — ההמלצות נכנסות אחרי `fetch`, והרכיב מתאתחל כשהוא נכנס לעמוד.
  // הכיוון מ-`dir` של `<html>`, כמו `theme.config.rtl`. בתנועה מופחתת בלי החלקה — כמו בסקשן 2.
  (function () {
    if (customElements.get('reci-gallery')) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var live = new Set();

    function modulo(a, b) {
      return ((a % b) + b) % b;
    }

    function pos(px, of) {
      return Math.round((px / (of || 1)) * 10000) / 100 + '%';
    }

    function measure(g) {
      g.w = g.el.clientWidth;
      g.cursor = g.w / 2;
      g.width = g.w * g.n;
      g.before = gapCells(g, g.cursor, g.n - 1, -1);
      g.after = gapCells(g, g.w - g.cursor, 0, 1);
    }

    function gapCells(g, gap, k, dir) {
      var list = [];
      while (gap > 0 && k >= 0 && k < g.n) {
        list.push(k);
        gap -= g.w;
        k += dir;
      }
      return list;
    }

    function renderCell(g, k, x) {
      g.cells[k].style.transform = 'translateX(' + pos(x * g.side, g.w) + ')';
    }

    function shiftWrapCells(g, e) {
      var gap = g.cursor + e;
      g.before.forEach(function (k) {
        renderCell(g, k, k * g.w + g.width * (gap > 0 ? -1 : 0));
        gap -= g.w;
      });
      gap = g.w - (e + g.width + g.cursor);
      g.after.forEach(function (k) {
        renderCell(g, k, k * g.w + g.width * (gap > 0 ? 1 : 0));
        gap -= g.w;
      });
    }

    function positionSlider(g) {
      var e = modulo(g.x, g.width) - g.width;
      shiftWrapCells(g, e);
      var v = pos((e + g.cursor) * g.side, g.w);
      g.slider.style.transform = g.animating ? 'translate3d(' + v + ',0,0)' : 'translateX(' + v + ')';
    }

    function animate(g) {
      g.v += (-(g.index * g.w + g.cursor) - g.x) * 0.025;
      var prev = g.x;
      g.x += g.v;
      g.v *= 0.72;
      positionSlider(g);
      if (Math.round(g.x * 100) === Math.round(prev * 100)) g.resting++;
      if (g.resting > 2) {
        g.animating = false;
        positionSlider(g);
      }
      if (g.animating) {
        requestAnimationFrame(function () {
          animate(g);
        });
      }
    }

    function select(g, i, instant) {
      var m = modulo(i, g.n);
      var o = Math.abs(m - g.index);
      var l = Math.abs(m + g.n - g.index);
      var h = Math.abs(m - g.n - g.index);
      if (l < o) i += g.n; else if (h < o) i -= g.n;
      if (i < 0) g.x -= g.width; else if (i >= g.n) g.x += g.width;
      i = modulo(i, g.n);
      var prev = g.index;
      g.index = i;
      g.cells.forEach(function (c, k) {
        c.classList.toggle('is-selected', k === i);
        if (k === i) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true');
      });
      if (instant || reduce.matches) {
        g.x = -(i * g.w + g.cursor);
        g.v = 0;
        positionSlider(g);
      } else if (!g.animating) {
        g.animating = true;
        g.resting = 0;
        animate(g);
      }
      g.dots.forEach(function (d, k) {
        d.classList.toggle('is-selected', k === i);
        if (k === i) d.setAttribute('aria-current', 'step'); else d.removeAttribute('aria-current');
      });
      if (i !== prev) g.el.setAttribute('data-selected-index', String(i));
    }

    function init(el) {
      var tpl = el.previousElementSibling;
      if (el.reciGallery || !tpl || tpl.tagName !== 'TEMPLATE' || !el.clientWidth) return;
      el.appendChild(tpl.content.cloneNode(true));
      var cells = Array.prototype.slice.call(el.querySelectorAll('.reci__gallery-cell'));
      if (cells.length < 2) return;
      var viewport = document.createElement('div');
      var slider = document.createElement('div');
      var holder = document.createElement('div');
      viewport.className = 'reci__gallery-viewport';
      slider.className = 'reci__gallery-slider';
      holder.className = 'reci__gallery-dots';
      cells.forEach(function (c) {
        slider.appendChild(c);
      });
      viewport.appendChild(slider);
      el.appendChild(viewport);
      // mezuzi 223.0 RL2 (Elad: the pictures move WITH the pointer): the hover strip is laid left-to-right on every page;
      // on an RTL page the thirds are mirrored instead (mousemove below) - a named deviation from inova
      var rtl = document.documentElement.getAttribute('dir') === 'rtl';
      var side = 1;
      var g = { el: el, side: side, cells: cells, n: cells.length, slider: slider, dots: [], index: 0, x: 0, v: 0, resting: 0, animating: false };
      cells.forEach(function (c, k) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'reci__gallery-dot';
        d.setAttribute('aria-label', 'תמונה ' + (k + 1));
        holder.appendChild(d);
        g.dots.push(d);
      });
      holder.addEventListener('click', function (e) {
        var k = g.dots.indexOf(e.target);
        if (k !== -1) select(g, k);
      });
      el.appendChild(holder);
      if (g.n === 2) el.classList.add('is-without-dots');
      el.reciGallery = g;
      measure(g);
      cells.forEach(function (c, k) {
        renderCell(g, k, k * g.w);
      });
      select(g, 0, true);
      el.classList.add('is-ready');
      el.addEventListener('mousemove', function (e) {
        if (g.n === 2) return select(g, 1);
        // mezuzi 223.0 RL1: drawn px (the .65 page zoom) -> css px, like g.w (rule 68); RL2: #1 under the RIGHT edge on RTL
        var mouseX = (e.clientX - el.getBoundingClientRect().left) / (el.currentCSSZoom || 1);
        if (rtl) mouseX = g.w - mouseX;
        if (g.n === 3) return select(g, mouseX < g.w / 2 ? 1 : 2);
        select(g, mouseX < g.w / 3 ? 1 : mouseX < (2 * g.w) / 3 ? 2 : 3);
      });
      el.addEventListener('mouseleave', function () {
        select(g, 0);
      });
    }

    var io = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            init(en.target);
            if (en.target.reciGallery) io.unobserve(en.target);
          });
        }, { rootMargin: '200px 0px 200px 0px' })
      : null;

    var timer = 0;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        live.forEach(function (el) {
          var g = el.reciGallery;
          if (!g || g.animating || !el.clientWidth) return;
          measure(g);
          g.cells.forEach(function (c, k) {
            renderCell(g, k, k * g.w);
          });
          select(g, g.index, true);
        });
      }, 150);
    });

    customElements.define('reci-gallery', class extends HTMLElement {
      connectedCallback() {
        live.add(this);
        if (io) io.observe(this);
        else init(this);
      }
      disconnectedCallback() {
        live.delete(this);
        if (io) io.unobserve(this);
      }
    });
  })();
  // 145.0 (head 68.0): both arrows hidden when everything fits - the source's rule (slider-element.updateButtons): previous
  // disabled = the first card visible at scroll 0, next disabled = the last card visible, BOTH -> both arrows hidden. Ours showed an
  // enabled "next" that moved nothing (4 cards inside at 1440). Horizon's slideshow-component[disabled] is no signal (true at 1279
  // too, where next works). The attribute is read by section-recommendations-inova.css.
  (function () {
    if (window.__reciFits) return;
    window.__reciFits = true;
    function inside(el, box) {
      var r = el.getBoundingClientRect();
      return r.left >= box.left - 1 && r.right <= box.right + 1;
    }
    function check(root) {
      var car = root.querySelector('slideshow-component.resource-list__carousel');
      var slides = car && car.querySelector(':scope > slideshow-container > slideshow-slides');
      if (!slides || !slides.children.length) return;
      var box = slides.getBoundingClientRect();
      var k = slides.children;
      car.toggleAttribute('data-reci-fits', inside(k[0], box) && inside(k[k.length - 1], box) && Math.abs(slides.scrollLeft) < 1);
    }
    function watch(root) {
      var queued = false;
      function soon() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          check(root);
        });
      }
      soon();
      if ('ResizeObserver' in window) new ResizeObserver(soon).observe(root);
      new MutationObserver(soon).observe(root, { childList: true, subtree: true });
      root.addEventListener('scroll', soon, true);
    }
    function start() {
      document.querySelectorAll('[id$="__recommendations_inova"]').forEach(watch);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-spy-inova"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // 🚨 **הערכה גוללת ב-`.page-wrapper` ולא בחלון.** נמדד 9.9.2026 שוב:
    // ‏`body` הוא `overflow: hidden` וגובהו 900, ו-`.page-wrapper` הוא
    // `overflow-y: auto` וגובה התוכן שלו 4366. **`window.scrollBy` אינו
    // מזיז דבר, `window.scrollY` תמיד 0, ואירוע `scroll` אינו מגיע
    // ל-`window`.** `LEARNED.md` סעיף ג. בלי זה הבר מסמן רק מה שלחצו
    // עליו ואינו עוקב אחרי הגלילה — **והוא נראה עובד.**
    // ⚠️ **ומי שגולל אינו אותו אחד בשני הרוחבים.** נמדד 9.9.2026 באותו
    // עמוד: ב-1440 `.page-wrapper` הוא `overflow-y: auto` וגובה תוכנו
    // 4366, וב-390 הוא `visible` ו-`scrollHeight` שווה ל-`clientHeight`
    // — כלומר שם גולל החלון. **פתרון שבוחר אחד מהם נכון בדיוק ברוחב
    // אחד**, ולכן אוספים את כל המועמדים וגוללים את כולם: מי שאינו
    // גליל פשוט אינו זז.
    function scrollersFor(el) {
      var out = [window];
      if (document.scrollingElement) out.push(document.scrollingElement);
      var n = el && el.parentElement;
      while (n && n !== document.body) {
        var ov = getComputedStyle(n).overflowY;
        if (ov === 'auto' || ov === 'scroll') out.push(n);
        n = n.parentElement;
      }
      return out.filter(function (x, i) {
        return out.indexOf(x) === i;
      });
    }

    function behavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    // 176.0 (Head 80.0): under reduce the jump must not glide - base.css sets scroll-behavior: smooth on html and
    // .page-wrapper unconditionally, so 'auto' glided too. No 'instant' (an unknown ScrollBehavior value throws on older
    // browsers and the click would do nothing): the scroller's inline scroll-behavior is auto for the call, then put back.
    function jumpTo(sc, top) {
      var el = sc === window ? document.documentElement : sc;
      var prev = el.style.scrollBehavior;
      el.style.scrollBehavior = 'auto';
      try {
        sc.scrollTo(0, top);
      } finally {
        el.style.scrollBehavior = prev;
      }
    }

    document.querySelectorAll('[data-ssp-nav]').forEach(function (nav) {
      var links = [].slice.call(nav.querySelectorAll('[data-ssp-target]'));
      var top = nav.querySelector('[data-ssp-top]');
      if (!links.length) return;

      var root = nav.closest('[id^="shopify-section-"]');
      var scrollers = scrollersFor(root || nav);

      // 176.0 (Head 80.0): the source's scroll-shadow Updater - start shade when scrolled away from the start, end shade
      // while content remains toward the end, floor() > 0, written in a frame; scroll + ResizeObserver. Its rtl branch never
      // lights the start shade (negative scrollLeft) - |scrollLeft| here. No script = no attribute = no shade.
      var shadeBox = nav.parentElement;
      var shadeQueued = false;
      function shade() {
        if (shadeQueued) return;
        shadeQueued = true;
        requestAnimationFrame(function () {
          shadeQueued = false;
          var x = Math.abs(nav.scrollLeft);
          shadeBox.toggleAttribute('data-shade-start', Math.floor(x) > 0);
          shadeBox.toggleAttribute('data-shade-end', Math.floor(nav.scrollWidth - nav.clientWidth - x) > 0);
        });
      }
      nav.addEventListener('scroll', shade, { passive: true });
      if (window.ResizeObserver) {
        var shadeRO = new ResizeObserver(shade);
        shadeRO.observe(nav);
        [].forEach.call(nav.querySelectorAll('.ssp__item'), function (li) {
          shadeRO.observe(li);
        });
      }
      shade();

      function idsOf(a) {
        return (a.getAttribute('data-ssp-target') || '').split(',').filter(function (id) {
          return id;
        });
      }

      // the source's headerHeight getter: the sticky header's box + 20,
      // or 20 when there is none and the bar is shorter than the screen.
      // 218.0: LAYOUT px (scrollBy / scrollTo take layout px; the rects are DRAWN px under the site zoom) - drawn / z, z = the
      // TARGET's zoom = the page's (MDN Element.currentCSSZoom; 1 below 1280), never the header's own (.67 at 1024-1279) - the
      // hotspot-linea 4ad56cd0 helper. Measured: 1518 landed 126 / 272 / 426 px short of the designed 20.
      var zf = function (el) { return el.currentCSSZoom || 1; };
      function headerHeight(z) {
        var header = document.querySelector('header-component[sticky]');
        if (header) return header.getBoundingClientRect().height / (z || 1) + 20;
        return nav.offsetHeight < window.innerHeight ? 20 : 0;
      }

      // 🔁 בוטל 14.9.2026 (53.0): "הקו = ראש `main` החי" (26.0 עם 51.0). החלטה 1 של אלעד
      // ("ב, שייצבע כמו במקור"), A עם הראש 28.0. ‏הכלל של המקור: פעיל כש-pageYOffset בתוך
      // [offsetTop, offsetTop+offsetHeight), ו-offsetTop יחסי ל-`main` — ואצלם ראש `main` = ההדר
      // + פס הודעות 48 (180 = 132+48 ב-1440, 140 = 92+48 ב-390, גם כשההדר מוסתר ב-transform).
      // לכן אחרי לחיצה (נחיתה = הדר + 20) הסקשן שנלחץ כבר פעיל. אצלנו אין פס: ראש `main` = ההדר,
      // הנחיתה 20 מתחת לקו ונצבעה הקודמת. ‏הקו = גובה ההדר החי + 48 (spy_rule v5, 1988a75).
      // ⚠️ לא ראש `main` + 48: אם יופעל אצלנו פס הודעות של 48 (header-announcements), זה יספור
      // את הפס פעמיים (188). ‏בלי הדר דביק הקו 48 — לא נמדד (בחנות ההדר תמיד דביק).
      // LEARNED שלט; START_HERE בלוק 53.0.
      function sync() {
        var header = document.querySelector('header-component[sticky]');
        var line = (header ? header.getBoundingClientRect().height : 0) + 48;
        var current = '';
        links.forEach(function (a) {
          idsOf(a).forEach(function (id) {
            var el = document.getElementById(id);
            if (!el) return;
            var r = el.getBoundingClientRect();
            if (r.top <= line && r.bottom > line) current = id;
          });
        });
        links.forEach(function (a) {
          var on = current !== '' && idsOf(a).indexOf(current) !== -1;
          a.classList.toggle('active', on);
          if (on) a.setAttribute('aria-current', 'location');
          else a.removeAttribute('aria-current');
        });
      }

      function by(delta) {
        if (behavior() === 'smooth') {
          scrollers.forEach(function (sc) {
            sc.scrollBy({ top: delta, behavior: 'smooth' });
          });
          return;
        }
        // absolute targets, read once before any move: window and scrollingElement scroll the same document,
        // and two instant relative scrolls would add up.
        var targets = scrollers.map(function (sc) {
          return (sc === window ? window.scrollY : sc.scrollTop) + delta;
        });
        scrollers.forEach(function (sc, i) {
          jumpTo(sc, targets[i]);
        });
      }

      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          var el = document.getElementById(idsOf(a)[0]);
          if (!el) return;
          e.preventDefault();
          var z = zf(el);
          by(el.getBoundingClientRect().top / z - headerHeight(z));
        });
      });

      if (top) {
        top.addEventListener('click', function () {
          scrollers.forEach(function (sc) {
            if (behavior() === 'smooth') sc.scrollTo({ top: 0, behavior: 'smooth' });
            else jumpTo(sc, 0);
          });
        });
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          sync();
          ticking = false;
        });
      }

      scrollers.forEach(function (sc) {
        sc.addEventListener('scroll', onScroll, { passive: true });
      });
      document.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set-picker"] && !Shopify.designMode) return;
  try {
    
  // בחירת גוון מחליפה את הגרסה שתישלח לסל, ומעדכנת את התווית שמתחת.
  // Theme 215.0: the source ALSO swaps the set picture to the chosen colour (Home 23.0's read of combine, 3 / 3) - the old line here
  // said 'the source does the same' about the label only, and the picture never changed (Elad 19.10). showPic() below = the picture.
  (function () {
    document.querySelectorAll('[data-spick-card]').forEach(function (card) {
      var json = card.querySelector('[data-spick-variants]');
      var idInput = card.querySelector('[data-spick-id]');
      var text = card.querySelector('[data-spick-opt-text]');
      if (!json || !idInput) return;

      var variants = [];
      try { variants = JSON.parse(json.textContent) || []; } catch (e) { return; }

      // Theme 215.0: the card picture = the chosen variant's own picture (the Liquid image_tag widths 358 / 432 / 864); no picture = no change.
      var pic = card.querySelector('.spick__img');
      var showPic = function (v) {
        if (!pic || !v || !v.featured_image || !v.featured_image.src) return;
        var s = v.featured_image.src;
        var u = function (w) { return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
        pic.srcset = u(358) + ' 358w, ' + u(432) + ' 432w, ' + u(864) + ' 864w';
        pic.src = u(864);
      };

      card.querySelectorAll('[data-spick-swatch]').forEach(function (input) {
        input.addEventListener('change', function () {
          var want = input.value;
          // ⚠️ המוצר עשוי להיות בעל כמה אופציות. מחפשים את הגרסה
          // הראשונה **הזמינה** שאחת מהאופציות שלה היא הגוון שנבחר,
          // ואם אין זמינה — הראשונה בכלל, כדי שלא יישלח מזהה ריק.
          // Theme 137.0 (SP1): רק בעמדת אופציית הצבע (`data-spick-pos`), ושומרים את שאר האופציות של הגרסה הנוכחית.
          // עד כאן נבדקה כל אופציה, ו"שחור" בחר "לבן / שחור / 10" — מזוזה לבנה עם שין שחורה, לסל.
          var group = input.closest('[data-spick-pos]');
          var pos = group ? parseInt(group.getAttribute('data-spick-pos'), 10) : 0;
          if (pos >= 1 && pos <= 3) {
            var key = 'option' + pos;
            var cur = null;
            for (var c = 0; c < variants.length; c++) if (String(variants[c].id) === idInput.value) cur = variants[c];
            var keep = null, avail = null, any = null;
            for (var j = 0; j < variants.length; j++) {
              var w = variants[j];
              if (w[key] !== want) continue;
              if (!any) any = w;
              if (w.available && !avail) avail = w;
              var same = !!cur;
              for (var o = 1; o <= 3 && same; o++) if (o !== pos && w['option' + o] !== cur['option' + o]) same = false;
              if (same && w.available) { keep = w; break; }
            }
            var got = keep || avail || any;
            if (got) {
              idInput.value = got.id;
              if (text) text.textContent = got.title;
              showPic(got);
            }
            return;
          }
          var match = null, fallback = null;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            var opts = [v.option1, v.option2, v.option3];
            if (opts.indexOf(want) === -1) continue;
            if (!fallback) fallback = v;
            if (v.available) { match = v; break; }
          }
          var picked = match || fallback;
          if (!picked) return;
          idInput.value = picked.id;
          if (text) text.textContent = picked.title;
          showPic(picked);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look-inova"] && !Shopify.designMode) return;
  try {
    
  // 253.0 candidates 13 + 14 (4.11.2026): one IntersectionObserver per section over every look dot, every card image wrapper and the look image
  // itself (.stli__look carries the same is-loading mark while its lazy photo loads - seen running off-screen at 390 on the first c13 rows); an element
  // that does not intersect the section's scroll container (+12 px) carries data-offscreen and its animation pauses (CSS above). Ancestors clip
  // the intersection, so a card in a hidden deck or slid out of the clipped viewport counts as off-screen; a card made active slides in and
  // resumes. Candidate 6c's shape (hotspot-rail.js): root = the nearest scrolling ancestor (div.page-wrapper on desktop, null = the document on
  // the phone - a margin on the implicit root is clipped at the scroller's edge otherwise, theme/LEARNED 3.11 252.0).
  (function () {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('.stli').forEach(function (stli) {
      var targets = Array.prototype.slice.call(stli.querySelectorAll('.stli__dot, .stli__card-media, .stli__look'));
      if (!targets.length) return;
      var root = stli.parentElement;
      while (root && root !== document.body && !(/(auto|scroll)/.test(getComputedStyle(root).overflowY) && root.scrollHeight > root.clientHeight)) root = root.parentElement;
      if (root === document.body) root = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) e.target.removeAttribute('data-offscreen');
          else e.target.setAttribute('data-offscreen', '');
        });
      }, { root: root, rootMargin: '12px' });
      targets.forEach(function (t) { io.observe(t); });
    });
  })();
  (function () {
    document.querySelectorAll('.stli').forEach(function (stli) {
      // 144.0: one carousel per look - a deck (cards + pager) and its pane (dots); no look block = the section, as before
      var decks = stli.querySelectorAll('[data-stli-deck]');
      var units = decks.length
        ? Array.prototype.map.call(decks, function (d) { return [d, stli.querySelector('[data-stli-pane="' + d.getAttribute('data-stli-deck') + '"]') || d]; })
        : [[stli, stli]];
      units.forEach(function (unit) {
      var root = unit[0];
      var dots = unit[1].querySelectorAll('[data-stli-dot]');
      var cards = root.querySelectorAll('[data-stli-card]');
      var pips = root.querySelectorAll('[data-stli-pip]');
      if (!cards.length) return;

      // 🚨 ההחלקה של עמודת הכרטיס — נמדדה 14.9.2026 (`review-stli-14.9/FINDINGS.md`, #13):
      // במקור, בכל פריים, `v += (t - x) * .025; x += v; v *= .72` (flickity בברירות המחדל),
      // עד 0.03px מהמדידה בכל פריים, בשני הרוחבים, קדימה ואחורה. המיקום נכתב באחוזים
      // מרוחב החלון מעוגלים ל-0.01, כמו flickity — בלי העיגול פריים ההגעה אינו תואם.
      // אצלנו במראה: הכרטיס הבא נכנס משמאל (RTL, החלטת הראש 29.0), ולכן היעד חיובי.
      // ✅ הוכרע: אלעד 10.10 Q1 "ב" — בתנועה מופחתת התנועה שלנו נעצרת (Theme 173.0).
      // ⏸ בתנועה מופחתת בלי החלקה — במקור ההחלקה ממשיכה (r12). מצב ביניים, כמו הפעימה.
      // 🔁 13g, 56.0 — שלושה כרטיסים ומעלה, מה-JS שהמקור מגיש (`review-stli-14.9/source-js/`, מצוטט):
      // flickity עם `wrapAround` — `_wrapSelect` הולך בדרך הקצרה סביב ושוויון הולך ישר (0→2 = צעד
      // אחורה דרך הגלישה, 2→0 = צעד קדימה); `positionSlider` מצייר `modulo(x, slideableWidth) −
      // slideableWidth`, ו-`shiftWrapCells` מזיז את הכרטיסים שבקצוות ברוחב הלולאה כדי שלא ייראה חור.
      // `CarouselElement.select` (theme.js) קופץ בלי החלקה כשהמרחק יותר מ-3, חוץ מראשון↔אחרון.
      // ⛔ עד 56.0 בלי גלישה, ישר מ-i ל-j — והכרטיס האמצעי חלף בחלון (`jump-red-13g.txt`).
      // 13i — `adaptiveHeight`: גובה החלון = הגובה החיצוני של הכרטיס הנבחר (`setGallerySize`).
      var track = root.querySelector('[data-stli-track]');
      var viewport = track ? track.parentElement : null;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var n = cards.length;
      var x = 0;
      var v = 0;
      var target = 0;
      var index = 0;
      var resting = 0;
      var raf = 0;
      var geo = null;

      function modulo(a, b) {
        return ((a % b) + b) % b;
      }

      function pct(px, of) {
        return Math.round((px / (of || 1)) * 10000) / 100;
      }

      // `getSize` + `_positionCells`: רוחב חיצוני = הקופסה ושני השוליים, הכרטיס ה-k בסכום הקודמים;
      // `cursorPosition` = חצי החלון (`cellAlign: center`); `_getGapCells` לשני הקצוות.
      // 218.0: the card rects and pageX are DRAWN px under the site zoom; clientWidth, the margins, the track translate and x are
      // LAYOUT px - drawn / the element's zoom (MDN Element.currentCSSZoom; 1 below 1280) - the hotspot-linea 4ad56cd0 helper.
      // Measured (Home 24 TABLE24 #3): at 1518 the window was .65 of the card (name + price cut), a dot left two halves.
      var zf = function (el) { return el.currentCSSZoom || 1; };
      function measure() {
        var w = viewport.clientWidth || 1;
        var sum = 0;
        geo = { w: w, cursor: w / 2, left: [], outer: [], cw: [] };
        cards.forEach(function (c) {
          var cs = window.getComputedStyle(c);
          var cw = c.getBoundingClientRect().width / zf(c);
          var o = cw + parseFloat(cs.marginLeft) + parseFloat(cs.marginRight);
          geo.left.push(sum);
          geo.outer.push(o);
          geo.cw.push(cw);
          sum += o;
        });
        geo.width = sum;
        geo.wrap = n > 1 && sum > 0;
        geo.before = gapCells(geo.cursor, n - 1, -1);
        geo.after = gapCells(w - geo.cursor, 0, 1);
      }

      function gapCells(gap, k, dir) {
        var list = [];
        while (gap > 0 && k >= 0 && k < n) {
          list.push(k);
          gap -= geo.outer[k];
          k += dir;
        }
        return list;
      }

      // `shiftWrapCells` / `_shiftCells` בסימן של flickity (קדימה שלילי); על הדף במראה.
      function shiftWrapCells(e) {
        var shift = [];
        var gap = geo.cursor + e;
        geo.before.forEach(function (k) {
          shift[k] = gap > 0 ? -1 : 0;
          gap -= geo.outer[k];
        });
        gap = geo.w - (e + geo.width + geo.cursor);
        geo.after.forEach(function (k) {
          shift[k] = gap > 0 ? 1 : 0;
          gap -= geo.outer[k];
        });
        cards.forEach(function (c, k) {
          var s = shift[k] || 0;
          c.style.transform = s ? 'translateX(' + pct(-s * geo.width, geo.cw[k]) + '%)' : '';
        });
      }

      function place(px) {
        var drawn = px;
        if (geo.wrap) {
          var e = modulo(-px - geo.cursor, geo.width) - geo.width;
          shiftWrapCells(e);
          drawn = -(e + geo.cursor);
        }
        track.style.transform = 'translateX(' + pct(drawn, geo.w) + '%)';
      }

      function setGallerySize() {
        var c = cards[index];
        var cs = window.getComputedStyle(c);
        viewport.style.height =
          c.getBoundingClientRect().height / zf(c) + parseFloat(cs.marginTop) + parseFloat(cs.marginBottom) + 'px';
      }

      function step() {
        var prev = x;
        // BP-1 M6 (199.0): while pressed the drag force replaces the attraction (Flickity applyDragForce / applySelectedAttraction)
        if (dg) v += dg.x - x - v;
        else v += (target - x) * 0.025;
        x += v;
        v *= 0.72;
        place(x);
        if (!dg && Math.round(x * 100) === Math.round(prev * 100)) resting++;
        if (resting > 2) {
          x = target;
          v = 0;
          raf = 0;
          place(x);
          return;
        }
        raf = requestAnimationFrame(step);
      }

      function slideTo(i, instant) {
        if (!track) return;
        measure();
        var from = index;
        if (Math.abs(i - from) > 3 && !(i === 0 && from === n - 1) && !(i === n - 1 && from === 0)) instant = true;
        if (geo.wrap) {
          var o = Math.abs(i - from);
          var l = Math.abs(i + n - from);
          var h = Math.abs(i - n - from);
          var t = l < o ? i + n : h < o ? i - n : i;
          if (t < 0) x += geo.width;
          else if (t >= n) x -= geo.width;
        }
        index = i;
        target = geo.left[i];
        setGallerySize();
        if (instant || reduce.matches) {
          if (raf) cancelAnimationFrame(raf);
          raf = 0;
          x = target;
          v = 0;
          place(x);
          return;
        }
        resting = 0;
        if (!raf) raf = requestAnimationFrame(step);
      }

      if (track) {
        measure();
        place(0);
        setGallerySize();
        window.addEventListener('resize', function () {
          slideTo(index, true);
        });
      }

      function show(i) {
        dots.forEach(function (d) {
          var on = d.getAttribute('data-stli-dot') === i;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        pips.forEach(function (p) {
          var on = p.getAttribute('data-stli-pip') === i;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        cards.forEach(function (c) {
          var on = c.getAttribute('data-stli-card') === i;
          c.classList.toggle('is-active', on);
          c.inert = !on;
          if (on) {
            c.removeAttribute('aria-hidden');
          } else {
            c.setAttribute('aria-hidden', 'true');
          }
        });
        if (Number(i) !== index) slideTo(Number(i));
      }

      // 🚨 במקור המעבר הוא **בריחוף ולא בלחיצה** — הנקודה שם היא
      // `hover-element`. נמדד 9.9.2026: `click()` תוכניתי על הנקודה
      // השנייה של inova אינו משנה דבר, לא `aria-current` ולא הכרטיס.
      // הלחיצה נשארת בשביל מגע ומקלדת.
      dots.forEach(function (d) {
        var go = function () {
          show(d.getAttribute('data-stli-dot'));
        };
        d.addEventListener('pointerenter', go);
        d.addEventListener('focus', go);
        d.addEventListener('click', go);
        // 🔁 132.0 (S2): במקור Enter / רווח על נקודה רק בוחרים — `keydown` עם `preventDefault`, ולכן הלחיצה (והחלון) לא קורים
        // (`LookbookElement` ב-theme.js של המקור; נמדד: Enter / Space ← הכרטיס מתחלף, חלון 0). הנקודה היא עכשיו גם פותחת חלון.
        d.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            go();
          }
        });
      });
      pips.forEach(function (p) {
        p.addEventListener('click', function () {
          show(p.getAttribute('data-stli-pip'));
        });
      });

      // 13e (ב): עמודת הכרטיסים היא עצירת Tab אחת, והחצים מחליפים כרטיס רק כשהעמודה עצמה בפוקוס —
      // כמו המקלדת של flickity במקור עם rightToLeft (ArrowLeft = הבא, מהאחרון חוזרים לראשון).
      // הראש 32.0 על תשובת אלעד, 14.9.2026: "תעשה שיהיה כמה שיותר נוח למשתמשים / ושיעבוד כמו שצריך".
      var column = stli.querySelector('.stli__cards');
      if (column) {
        column.addEventListener('keydown', function (e) {
          if (root.hidden || e.target !== column || n < 2 || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
          var at = 0;
          cards.forEach(function (c, k) {
            if (c.classList.contains('is-active')) at = k;
          });
          show(cards[(at + (e.key === 'ArrowLeft' ? 1 : n - 1)) % n].getAttribute('data-stli-card'));
        });
      }

      // BP-1 M6 (199.0): the source deck drags (Flickity 3 drag.js + Unidragger, vendor.js; review-199/m6/src-drag-code.txt) in our own
      // physics loop: a press, a move > 3 px across = a drag; while pressed the deck follows; on release the resting position x + v / 0.28
      // picks the closest card, and a release <= 100 ms after a move toward the next / previous card boosts +-1; a click right after a drag
      // is eaten; a page scroll > 3 px while pressed ends the press. Our x = -(Flickity x); in RTL the two signs cancel (side +1).
      var dg = null;
      var dgEat = false;
      var dgSide = document.documentElement.getAttribute('dir') === 'rtl' ? 1 : -1;
      var dgTouch = 'ontouchstart' in window;
      function dgDist(px, i) {
        return px - (geo.left[modulo(i, n)] + geo.width * Math.floor(i / n));
      }
      function dgClosest(rest, d, dir) {
        var s = index;
        var m = Infinity;
        while (d < m) {
          s += dir;
          m = d;
          d = Math.abs(dgDist(rest, s));
        }
        return { distance: m, index: s - dir };
      }
      function dgOff() {
        window.removeEventListener(dgTouch ? 'touchmove' : 'pointermove', dgMove);
        window.removeEventListener(dgTouch ? 'touchend' : 'pointerup', dgUp);
        window.removeEventListener(dgTouch ? 'touchcancel' : 'pointercancel', dgCancel);
        window.removeEventListener('scroll', dgScroll);
        viewport.classList.remove('is-pointer-down');
      }
      function dgCancel() {
        if (!dg) return;
        var was = dg;
        dgOff();
        dg = null;
        if (was.on) dgEnd(was);
      }
      function dgScroll() {
        if (dg && (Math.abs(window.pageXOffset - dg.sx) > 3 || Math.abs(window.pageYOffset - dg.sy) > 3)) {
          dgOff();
          dg = null;
        }
      }
      function dgEnd(was) {
        var rest = x + v / 0.28;
        var d = Math.abs(dgDist(rest, index));
        var a = dgClosest(rest, d, 1);
        var b = dgClosest(rest, d, -1);
        var i = a.distance < b.distance ? a.index : b.index;
        if (i === index && was.prev !== undefined && Date.now() - was.moved <= 100) {
          var t = dgDist(was.x, index);
          var e = was.x - was.prev;
          i += t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0;
        }
        if (i < 0) x += geo.width;
        else if (i >= n) x -= geo.width;
        i = modulo(i, n);
        index = i;
        target = geo.left[i];
        show(String(i));
        setGallerySize();
        if (reduce.matches) {
          if (raf) cancelAnimationFrame(raf);
          raf = 0;
          x = target;
          v = 0;
          place(x);
          return;
        }
        resting = 0;
        if (!raf) raf = requestAnimationFrame(step);
      }
      function dgMove(e) {
        if (!dg) return;
        var p = e.touches ? e.touches[0] : e;
        var dx = p.pageX - dg.x0;
        if (!dg.on) {
          if (Math.abs(dx) <= 3) return;
          dg.on = true;
          dgEat = true;
          measure();
          dg.start = x;
          window.removeEventListener('scroll', dgScroll);
          resting = 0;
          if (!raf) raf = requestAnimationFrame(step);
        }
        e.preventDefault();
        dg.prev = dg.x;
        dx /= zf(viewport); // 218.0: the 3 px start threshold above stays in drawn px, as today
        if (geo.wrap) dx %= geo.width;
        dg.x = dg.start + dx * dgSide;
        dg.moved = Date.now();
      }
      function dgUp() {
        if (!dg) return;
        var was = dg;
        dgOff();
        dg = null;
        if (was.on) {
          dgEnd(was);
          setTimeout(function () { dgEat = false; });
        }
      }
      function dgDown(e) {
        var p = e.touches ? e.touches[0] : e;
        if (dg || root.hidden || (!e.touches && e.button) || e.target.closest('input, textarea, select')) return;
        if (!e.touches) e.preventDefault();
        dg = { x0: p.pageX, sx: window.pageXOffset, sy: window.pageYOffset, on: false, x: x, prev: undefined, moved: 0 };
        viewport.classList.add('is-pointer-down');
        window.addEventListener(dgTouch ? 'touchmove' : 'pointermove', dgMove, { passive: false });
        window.addEventListener(dgTouch ? 'touchend' : 'pointerup', dgUp);
        window.addEventListener(dgTouch ? 'touchcancel' : 'pointercancel', dgCancel);
        window.addEventListener('scroll', dgScroll);
      }
      if (track && n > 1) {
        viewport.addEventListener(dgTouch ? 'touchstart' : 'pointerdown', dgDown, { passive: false });
        viewport.addEventListener('click', function (e) {
          if (dgEat) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
      }
      });
    });
  })();

  // 144.0 (head 68.0): the bubbles - hotspot-rail's select() / play() (`assets/hotspot-rail.js`, the source's MediaLookbook as one Motion
  // sequence on the Web Animations API, frame-matched in 85.0-87.0). A press: aria-current moves, the looks swap (the hidden one stays
  // laid out, invisible); the old cards out (opacity 1->0, y 0->30, .4s), the new in (.4s from +.2s), the new picture wiped in
  // (inset-right 100% -> 0%, .4s from +.2s), the new look's dots in (opacity 0->1, scale .8->1, .5s, stagger .3s). Every animation is
  // stamped with the moment of the press. First time in view (amount .3, once): the bubbles in (opacity 0->1, x -30->0, .3s, stagger .2s).
  (function () {
    var EASE = 'cubic-bezier(0, 0, 0.58, 1)';
    var fresh = function (el) {
      el.getAnimations().forEach(function (a) {
        if (!(a instanceof CSSTransition) && !(a instanceof CSSAnimation)) a.cancel();
      });
    };
    var stamp = function (list, t) {
      list.forEach(function (a) { a.startTime = t; });
    };
    document.querySelectorAll('.stli').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.stli__bubble'));
      if (tabs.length < 2) return;
      var panes = Array.prototype.slice.call(root.querySelectorAll('[data-stli-pane]'));
      var decks = Array.prototype.slice.call(root.querySelectorAll('[data-stli-deck]'));
      var index = 0;

      function play(prev, at) {
        var i = index;
        var deck = decks[i];
        var img = panes[i] && panes[i].querySelector('.stli__img');
        var pins = panes[i] ? Array.prototype.slice.call(panes[i].querySelectorAll('.stli__dot')) : [];
        var t0 = prev === null ? 0 : 200;
        var opts = function (delay, duration) { return { delay: delay, duration: duration, easing: EASE, fill: 'both' }; };
        var made = [];
        // Theme 173.0 (Q1 "ב"): with reduced motion the look is simply there - cancel what was running, animate nothing
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          [prev !== null ? decks[prev] : null, deck, img].concat(pins).forEach(function (e) { if (e) fresh(e); });
          return;
        }
        if (prev !== null && decks[prev]) {
          fresh(decks[prev]);
          made.push(decks[prev].animate([{ opacity: 1, transform: 'translateY(0px)' }, { opacity: 0, transform: 'translateY(30px)' }], opts(0, 400)));
        }
        if (deck) {
          fresh(deck);
          made.push(deck.animate([{ opacity: 0, transform: 'translateY(30px)' }, { opacity: 1, transform: 'translateY(0px)' }], opts(t0, 400)));
        }
        if (img) {
          fresh(img);
          made.push(img.animate([{ clipPath: 'inset(0 100% 0 0)' }, { clipPath: 'inset(0 0% 0 0)' }], opts(t0, 400)));
        }
        pins.forEach(function (p, k) {
          fresh(p);
          made.push(p.animate([{ opacity: 0, transform: 'scale(0.8)' }, { opacity: 1, transform: 'scale(1)' }], opts(t0 + 400 + 300 * k, 500)));
        });
        stamp(made, at);
      }

      function select(i) {
        if (i === index) return;
        var at = performance.now();
        var prev = index;
        index = i;
        tabs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
        panes.forEach(function (p, k) { p.hidden = k !== i; });
        decks.forEach(function (d, k) { d.hidden = k !== i; });
        play(prev, at);
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
      });

      // Theme 173.0 (#120, Head 79.0): the hidden state is ARMED here, by the script - the markup renders no attribute - so a blocked or
      // throwing script leaves the bubbles visible (LEARNED תתקלב). Reduced motion (Q1 "ב") and no IntersectionObserver never arm.
      var rail = root.querySelector('.stli__bubbles');
      if (!rail) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      rail.setAttribute('data-stli-reveal', '');
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        var at = performance.now();
        io.disconnect();
        // disarm first: the keyframes below (fill 'both', with their delay) hold each bubble at its start - no flash, and a throw after this
        // line still leaves them visible
        rail.removeAttribute('data-stli-reveal');
        stamp(tabs.map(function (t, k) {
          return t.animate([{ opacity: 0, transform: 'translateX(-30px)' }, { opacity: 1, transform: 'translateX(0px)' }],
            { delay: 200 * k, duration: 300, easing: EASE, fill: 'both' });
        }), at);
      }, { threshold: 0.3 });
      io.observe(rail);
    });
  })();

  // 🚨 #9a — גלריית הריחוף על תמונת הכרטיס, ≥ 1024 בלבד. ‏63.0, 15.9.2026 (`review-stli-14.9/FINDINGS.md`, 13e).
  // במקור `SecondaryMedia` (theme.js) על flickity (vendor.js), מצוטטים ב-`review-stli-14.9/source-js/`
  // (`theme.js.SecondaryMedia-62.txt`, `vendor.js.flickity-63.txt`, `vendor.js.excerpts-56.txt`):
  // עד 4 מדיה בתבנית, בסדר המדיה · אתחול כשהגלריה במרחק 200px מהמסך (`Motion.inView`) · `mousemove`: ‏2 → 1,
  // ‏3 → חצאים, 4 → שלישים, ‏mouseX מהקצה השמאלי גם ב-RTL · `mouseleave` → 0 · `wrapAround`: ‏`_wrapSelect` בדרך
  // הקצרה, שוויון הולך ישר · הפיזיקה של flickity כמו בעמודת הכרטיס, בלי הצמדה ליעד במנוחה (flickity אינו מצמיד) ·
  // הכיוון מ-`dir` של `<html>`, כמו `theme.config.rtl` — ⛔ לא `true` קבוע.
  // ✅ הוכרע: אלעד 10.10 Q1 "ב" — בתנועה מופחתת התנועה שלנו נעצרת (Theme 173.0).
  // ⏸ בתנועה מופחתת בלי החלקה — מצב הביניים של הסקשן (השאלה הפתוחה מ-54.0 / 30.0).
  // הראש 37.0: פונקציה נפרדת; הקוד של עמודת הכרטיס לא נגע (מפעל משותף — מועמד לערכה).
  (function () {
    var rtl = document.documentElement.getAttribute('dir') === 'rtl';
    // mezuzi 223.0 RL2 (Elad: the pictures move WITH the pointer): the hover strip is laid left-to-right on every page;
    // on an RTL page the thirds are mirrored instead (mousemove below) - a named deviation from inova
    var side = 1;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var galleries = document.querySelectorAll('.stli [data-stli-gallery]');
    if (!galleries.length) return;

    function modulo(a, b) {
      return ((a % b) + b) % b;
    }

    // `getPositionValue`: אחוזים מרוחב הגלריה, מעוגלים ל-0.01.
    function pos(px, of) {
      return Math.round((px / (of || 1)) * 10000) / 100 + '%';
    }

    // `getSize` + `_updateWrapShiftCells` + `_getGapCells`: כל תא ברוחב הגלריה, `cellAlign: center`.
    function measure(g) {
      g.w = g.el.clientWidth;
      g.cursor = g.w / 2;
      g.width = g.w * g.n;
      g.before = gapCells(g, g.cursor, g.n - 1, -1);
      g.after = gapCells(g, g.w - g.cursor, 0, 1);
    }

    function gapCells(g, gap, k, dir) {
      var list = [];
      while (gap > 0 && k >= 0 && k < g.n) {
        list.push(k);
        gap -= g.w;
        k += dir;
      }
      return list;
    }

    // `_renderCellPosition`
    function renderCell(g, k, x) {
      g.cells[k].style.transform = 'translateX(' + pos(x * side, g.w) + ')';
    }

    // `shiftWrapCells` / `_shiftCells` / `_wrapShiftCell`
    function shiftWrapCells(g, e) {
      var gap = g.cursor + e;
      g.before.forEach(function (k) {
        renderCell(g, k, k * g.w + g.width * (gap > 0 ? -1 : 0));
        gap -= g.w;
      });
      gap = g.w - (e + g.width + g.cursor);
      g.after.forEach(function (k) {
        renderCell(g, k, k * g.w + g.width * (gap > 0 ? 1 : 0));
        gap -= g.w;
      });
    }

    // `positionSlider` + `setTranslateX`
    function positionSlider(g) {
      var e = modulo(g.x, g.width) - g.width;
      shiftWrapCells(g, e);
      var v = pos((e + g.cursor) * side, g.w);
      g.slider.style.transform = g.animating ? 'translate3d(' + v + ',0,0)' : 'translateX(' + v + ')';
    }

    // `animate`: `applySelectedAttraction` · `integratePhysics` · `positionSlider` · `settle`
    function animate(g) {
      g.v += (-(g.index * g.w + g.cursor) - g.x) * 0.025;
      var prev = g.x;
      g.x += g.v;
      g.v *= 0.72;
      positionSlider(g);
      if (Math.round(g.x * 100) === Math.round(prev * 100)) g.resting++;
      if (g.resting > 2) {
        g.animating = false;
        positionSlider(g);
      }
      if (g.animating) {
        requestAnimationFrame(function () {
          animate(g);
        });
      }
    }

    // `select` + `_wrapSelect` + `PageDots.updateSelected`
    function select(g, i, instant) {
      var m = modulo(i, g.n);
      var o = Math.abs(m - g.index);
      var l = Math.abs(m + g.n - g.index);
      var h = Math.abs(m - g.n - g.index);
      if (l < o) i += g.n; else if (h < o) i -= g.n;
      if (i < 0) g.x -= g.width; else if (i >= g.n) g.x += g.width;
      i = modulo(i, g.n);
      var prev = g.index;
      g.index = i;
      g.cells.forEach(function (c, k) {
        c.classList.toggle('is-selected', k === i);
        if (k === i) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true');
      });
      if (instant || reduce.matches) {
        g.x = -(i * g.w + g.cursor);
        g.v = 0;
        positionSlider(g);
      } else if (!g.animating) {
        g.animating = true;
        g.resting = 0;
        animate(g);
      }
      g.dots.forEach(function (d, k) {
        d.classList.toggle('is-selected', k === i);
        if (k === i) d.setAttribute('aria-current', 'step'); else d.removeAttribute('aria-current');
      });
      if (i !== prev) g.el.setAttribute('data-selected-index', String(i));
    }

    // `SecondaryMedia.init`: התבנית נכנסת לגלריה, ואז flickity (`accessibility: false`, `draggable: false`,
    // `pageDots: true`, `prevNextButtons: false`, `wrapAround: true`).
    function init(el) {
      var tpl = el.previousElementSibling;
      if (el.stliGallery || !tpl || tpl.tagName !== 'TEMPLATE') return;
      el.appendChild(tpl.content.cloneNode(true));
      // BP-1 M2 (199.0): the stamped gallery imgs load like every other stl img (the inline lazy() hung on the section).
      var stliSec = el.closest('.stli');
      if (stliSec && stliSec.stliLazy) Array.prototype.forEach.call(el.querySelectorAll('img'), stliSec.stliLazy);
      var cells = Array.prototype.slice.call(el.querySelectorAll('.stli__gallery-cell'));
      if (cells.length < 2) return;
      var viewport = document.createElement('div');
      var slider = document.createElement('div');
      var holder = document.createElement('div');
      viewport.className = 'stli__gallery-viewport';
      slider.className = 'stli__gallery-slider';
      holder.className = 'stli__gallery-dots';
      cells.forEach(function (c) {
        slider.appendChild(c);
      });
      viewport.appendChild(slider);
      el.appendChild(viewport);
      var g = { el: el, cells: cells, n: cells.length, slider: slider, dots: [], index: 0, x: 0, v: 0, resting: 0, animating: false };
      cells.forEach(function (c, k) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'stli__gallery-dot';
        d.setAttribute('aria-label', 'תמונה ' + (k + 1));
        holder.appendChild(d);
        g.dots.push(d);
      });
      holder.addEventListener('click', function (e) {
        var k = g.dots.indexOf(e.target);
        if (k !== -1) select(g, k);
      });
      el.appendChild(holder);
      if (g.n === 2) el.classList.add('is-without-dots');
      el.stliGallery = g;
      measure(g);
      cells.forEach(function (c, k) {
        renderCell(g, k, k * g.w);
      });
      select(g, 0, true);
      el.classList.add('is-ready');
      el.addEventListener('mousemove', function (e) {
        if (g.n === 2) return select(g, 1);
        // mezuzi 223.0 RL1: drawn px (the .65 page zoom) -> css px, like g.w (rule 68); RL2: #1 under the RIGHT edge on RTL
        var mouseX = (e.clientX - el.getBoundingClientRect().left) / (el.currentCSSZoom || 1);
        if (rtl) mouseX = g.w - mouseX;
        if (g.n === 3) return select(g, mouseX < g.w / 2 ? 1 : 2);
        select(g, mouseX < g.w / 3 ? 1 : mouseX < (2 * g.w) / 3 ? 2 : 3);
      });
      el.addEventListener('mouseleave', function () {
        select(g, 0);
      });
    }

    // `onresize` (debounce 150) → `resize`: לא באמצע תנועה; מיקום מחדש מיידי על הנבחר.
    var timer = 0;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        galleries.forEach(function (el) {
          var g = el.stliGallery;
          if (!g || g.animating || !el.clientWidth) return;
          measure(g);
          g.cells.forEach(function (c, k) {
            renderCell(g, k, k * g.w);
          });
          select(g, g.index, true);
        });
      }, 150);
    });

    if (!('IntersectionObserver' in window)) {
      galleries.forEach(function (el) {
        init(el);
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        init(en.target);
      });
    }, { rootMargin: '200px 0px 200px 0px' });
    galleries.forEach(function (el) {
      io.observe(el);
    });
  })();
  // BP-4 S4 (197.0): the source LookbookElement intro - inView + image loaded -> 1000 ms -> every hotspot open -> 3000 ms -> all closed. Once.
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var looks = document.querySelectorAll('.stli__look');
    if (!looks.length) return;
    var run = function (look) {
      look.classList.add('is-intro');
      setTimeout(function () { look.classList.remove('is-intro'); }, 3000);
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var img = en.target.querySelector('img');
        var go = function () { setTimeout(function () { run(en.target); }, 1000); };
        if (!img || img.complete) go(); else { img.addEventListener('load', go, { once: true }); img.addEventListener('error', go, { once: true }); }
      });
    });
    Array.prototype.forEach.call(looks, function (l) { io.observe(l); });
  })();

  } catch(e) { console.error(e); }
})();
})();
